import React, { useState, useEffect } from 'react';

export const AddProjectFooterIllustration = () => {
  const [primaryColor, setPrimaryColor] = useState('#ffd800');

  const storedTheme = JSON.parse(localStorage.getItem('themeSettings')) || '';

  useEffect(() => {
    if (storedTheme !== '') {
      setPrimaryColor(storedTheme?.primaryColor);
    }
  }, [storedTheme]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="865.134"
      height="228.001"
      viewBox="0 0 865.134 228.001"
    >
      <g
        id="Group_42043"
        data-name="Group 42043"
        transform="translate(-995.866 -1039)"
      >
        <g
          id="Group_42038"
          data-name="Group 42038"
          transform="translate(-11276.027 10816.206)"
        >
          <g
            id="Group_41787"
            data-name="Group 41787"
            transform="translate(12278.504 -9777.206)"
          >
            <path
              id="Path_64585"
              data-name="Path 64585"
              d="M250.7,471.873h-.579V468.01h.579Zm0-7.726h-.579v-3.863h.579Zm0-7.726h-.579v-3.863h.579Zm0-7.726h-.579v-3.863h.579Zm138-3.923h-1.75v-.579h1.171V442.08h.579Zm-5.613,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Zm-116.932-3.8h-.579v-3.863h.579Zm138-2.752h-.579v-3.863h.579Zm-138-4.974h-.579V429.38h.579Zm138-2.752h-.579v-3.863h.579Zm-138-4.974h-.579v-3.863h.579Zm138-2.752h-.579V418.9h.579Zm-138-4.974h-.579v-3.863h.579Zm138-2.752h-.579v-3.863h.579Zm-3.061-4.665H381.77v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579H347Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579H316.1Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0H281.33v-.579h3.863Zm-7.726,0H273.6v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Zm-7.726,0h-3.863v-.579h3.863Z"
              transform="translate(-250.117 -409.794)"
              fill="#3b4046"
            />
          </g>
          <g
            id="Group_41788"
            data-name="Group 41788"
            transform="translate(12301.522 -9752.597)"
          >
            <path
              id="Path_64586"
              data-name="Path 64586"
              d="M319.828,720.076c3.555,18.921,17.224,35.289,34.582,43.616s37.948,8.919,56.318,3.157c16.673-5.23,32.057-15.485,49.5-16.541,28-1.7,53.2,20.7,81.208,19.229,19.558-1.027,37.793-15.02,43.847-33.646s-.469-40.666-15.684-53c-7.8-6.319-18.606-12.016-18.838-22.05-.234-10.156,10.677-16.479,15.991-25.138,7.031-11.458,3.129-27.544-6.9-36.5s-24.688-11.4-37.9-8.9-25.189,9.386-36.084,17.261c-10.306,7.449-20.58,16.179-33.167,17.988-14.2,2.041-27.835-5.167-41.358-9.954-17-6.018-40.727-6.191-46.134,14.995-1.343,5.264-1.683,10.746-3.052,16a42.237,42.237,0,0,1-11.071,19.075c-5.51,5.505-12.55,7.429-18.476,11.847C319.987,686.937,317.109,705.6,319.828,720.076Z"
              transform="translate(-318.89 -589.384)"
              fill="#ffffe1"
            />
          </g>
          <g
            id="Group_41799"
            data-name="Group 41799"
            transform="translate(12420.165 -9712.492)"
          >
            <g
              id="Group_41789"
              data-name="Group 41789"
              transform="translate(10.358 22.101)"
            >
              <path
                id="Path_64587"
                data-name="Path 64587"
                d="M1037.16,859.486l4.024,23.8,1.406-.245.4-23.783Z"
                transform="translate(-1037.16 -859.255)"
                fill="#3b4046"
              />
            </g>
            <g
              id="Group_41793"
              data-name="Group 41793"
              transform="translate(6.591 0)"
            >
              <g
                id="Group_41790"
                data-name="Group 41790"
                transform="translate(1.078 3.887)"
              >
                <path
                  id="Path_64588"
                  data-name="Path 64588"
                  d="M1032.15,783.159l-6.566.26c-1.795-4.369-3.364-14-1.523-18.457l7.364,1.669Z"
                  transform="translate(-1023.238 -764.961)"
                  fill="#3b4046"
                />
              </g>
              <g
                id="Group_41791"
                data-name="Group 41791"
                transform="translate(0)"
              >
                <circle
                  id="Ellipse_1316"
                  data-name="Ellipse 1316"
                  cx="3.844"
                  cy="3.844"
                  r="3.844"
                  transform="translate(0 5.254) rotate(-43.108)"
                  fill="#3b4046"
                />
              </g>
              <g
                id="Group_41792"
                data-name="Group 41792"
                transform="translate(5.423 5.429)"
                opacity="0"
              >
                <path
                  id="Path_64589"
                  data-name="Path 64589"
                  d="M1045.732,772.943h0Z"
                  transform="translate(-1045.73 -772.942)"
                  fill="#3b4046"
                />
              </g>
            </g>
            <g
              id="Group_41794"
              data-name="Group 41794"
              transform="translate(0.631 21.333)"
            >
              <path
                id="Path_64590"
                data-name="Path 64590"
                d="M989.006,855.279,986.8,879.312l1.422.123,6.478-22.887S989.006,855.278,989.006,855.279Z"
                transform="translate(-986.8 -855.279)"
                fill="#3b4046"
              />
            </g>
            <g
              id="Group_41795"
              data-name="Group 41795"
              transform="translate(2.322 1.573)"
            >
              <path
                id="Path_64591"
                data-name="Path 64591"
                d="M1003.1,753.144a3.845,3.845,0,0,0-4.116,1.289h0l-.015.02q-.1.13-.193.269c-2.756,4.011-3.648,13.373-3.047,17.943l6.413,1.43,3.532-16.16v0A3.843,3.843,0,0,0,1003.1,753.144Z"
                transform="translate(-995.553 -752.981)"
                fill="#3b4046"
              />
            </g>
            <g
              id="Group_41796"
              data-name="Group 41796"
              transform="translate(2.203 5.877)"
            >
              <path
                id="Path_64592"
                data-name="Path 64592"
                d="M1002.587,787.778l-.938,4.294-1.064-.237-.015.126,1.175.262.966-4.421Zm-5.721-12.518a30.176,30.176,0,0,0-1.489,6.182c-.006.041-.012.082-.018.124l.126.012a30.58,30.58,0,0,1,1.486-6.239Zm-1.928,11.509.127-.022c.02-1.052.086-2.172.2-3.313l-.126-.006C995.025,784.566,994.959,785.7,994.938,786.769Zm.3,3.872c-.083-.632-.138-1.355-.163-2.143l-.127.016c.025.78.079,1.5.163,2.143l.012.088,3.874.864.043-.12Zm9.039-10.582-.838,3.836h.129l.839-3.836Z"
                transform="translate(-994.938 -775.26)"
                fill="#3b4046"
              />
            </g>
            <g
              id="Group_41797"
              data-name="Group 41797"
              transform="translate(0 45.366)"
            >
              <path
                id="Path_64593"
                data-name="Path 64593"
                d="M988.675,981.284a.83.83,0,0,0-.49-.336,5.038,5.038,0,0,0-.6-.1,3.216,3.216,0,0,1-1.365-.568,4.776,4.776,0,0,0-.636-.446l-1.422-.123a1.635,1.635,0,0,0-.465.721,2.883,2.883,0,0,0-.133.772l-.033.3,5.2.588.033-.3h0A.794.794,0,0,0,988.675,981.284Z"
                transform="translate(-983.532 -979.707)"
                fill="#3b4046"
              />
            </g>
            <g
              id="Group_41798"
              data-name="Group 41798"
              transform="translate(14.114 45.883)"
            >
              <path
                id="Path_64594"
                data-name="Path 64594"
                d="M1061.638,983a.829.829,0,0,0-.56-.2,5.034,5.034,0,0,0-.606.054,3.217,3.217,0,0,1-1.465-.2,4.782,4.782,0,0,0-.729-.268l-1.406.245a1.633,1.633,0,0,0-.265.817,2.875,2.875,0,0,0,.069.78l.043.294,5.177-.763-.044-.294h0A.8.8,0,0,0,1061.638,983Z"
                transform="translate(-1056.603 -982.383)"
                fill="#3b4046"
              />
            </g>
          </g>
          <g
            id="Group_41815"
            data-name="Group 41815"
            transform="translate(12313.273 -9696.338)"
          >
            <g
              id="Group_41800"
              data-name="Group 41800"
              transform="translate(0 131.481)"
            >
              <path
                id="Path_64595"
                data-name="Path 64595"
                d="M650.271,1509.18h0c0,5.861-3.651,10.612-8.154,10.612H438.278c-4.5,0-8.154-4.751-8.154-10.612H650.271Z"
                transform="translate(-430.124 -1509.18)"
                fill="#3b4046"
              />
            </g>
            <g
              id="Group_41801"
              data-name="Group 41801"
              transform="translate(21.772 11.699)"
            >
              <rect
                id="Rectangle_20086"
                data-name="Rectangle 20086"
                width="176.602"
                height="110.92"
                fill="#84a9ff"
              />
            </g>
            <g
              id="Group_41802"
              data-name="Group 41802"
              transform="translate(12.506 0)"
            >
              <path
                id="Path_64596"
                data-name="Path 64596"
                d="M501.048,828.471H683.827A6.178,6.178,0,0,1,690,834.649v117.1a6.178,6.178,0,0,1-6.178,6.178H501.048a6.178,6.178,0,0,1-6.178-6.178v-117.1A6.178,6.178,0,0,1,501.048,828.471Z"
                transform="translate(-494.87 -828.471)"
                fill="#3b4046"
              />
            </g>
            <g
              id="Group_41803"
              data-name="Group 41803"
              transform="translate(21.772 9.267)"
            >
              <rect
                id="Rectangle_20087"
                data-name="Rectangle 20087"
                width="176.602"
                height="110.92"
                fill="#fff"
              />
            </g>
            <g
              id="Group_41806"
              data-name="Group 41806"
              transform="translate(40.188 127.067)"
            >
              <g
                id="Group_41804"
                data-name="Group 41804"
                transform="translate(95.36)"
              >
                <path
                  id="Path_64597"
                  data-name="Path 64597"
                  d="M1131.89,1490.744h44.41l-.156-1.964-.2-2.449h-43.707Z"
                  transform="translate(-1131.89 -1486.33)"
                  fill="#e5e6eb"
                />
              </g>
              <g id="Group_41805" data-name="Group 41805">
                <path
                  id="Path_64598"
                  data-name="Path 64598"
                  d="M638.188,1490.744H682.6l-.157-1.964-.2-2.449H638.54Z"
                  transform="translate(-638.188 -1486.33)"
                  fill="#e5e6eb"
                />
              </g>
            </g>
            <g
              id="Group_41814"
              data-name="Group 41814"
              transform="translate(21.772 9.267)"
            >
              <g id="Group_41807" data-name="Group 41807">
                <rect
                  id="Rectangle_20088"
                  data-name="Rectangle 20088"
                  width="176.602"
                  height="110.92"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_41808"
                data-name="Group 41808"
                transform="translate(8.693 84.897)"
              >
                <rect
                  id="Rectangle_20089"
                  data-name="Rectangle 20089"
                  width="159.218"
                  height="17.332"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41809"
                data-name="Group 41809"
                transform="translate(56.875 49.743)"
              >
                <rect
                  id="Rectangle_20090"
                  data-name="Rectangle 20090"
                  width="111.036"
                  height="31.291"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41810"
                data-name="Group 41810"
                transform="translate(8.693 24.247)"
              >
                <rect
                  id="Rectangle_20091"
                  data-name="Rectangle 20091"
                  width="159.218"
                  height="21.633"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41811"
                data-name="Group 41811"
                transform="translate(8.693 8.691)"
              >
                <rect
                  id="Rectangle_20092"
                  data-name="Rectangle 20092"
                  width="159.218"
                  height="11.693"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41812"
                data-name="Group 41812"
                transform="translate(8.693 49.743)"
              >
                <rect
                  id="Rectangle_20093"
                  data-name="Rectangle 20093"
                  width="44.319"
                  height="13.714"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41813"
                data-name="Group 41813"
                transform="translate(8.693 67.32)"
              >
                <rect
                  id="Rectangle_20094"
                  data-name="Rectangle 20094"
                  width="44.319"
                  height="13.714"
                  fill="#e5e6eb"
                />
              </g>
            </g>
          </g>
          <g
            id="Group_41818"
            data-name="Group 41818"
            transform="translate(12271.894 -9708.699)"
          >
            <g
              id="Group_41816"
              data-name="Group 41816"
              transform="translate(13.826 6.592)"
            >
              <path
                id="Path_64599"
                data-name="Path 64599"
                d="M295.011,802.463l-2.424-2.124-2.558,2.263,1.809,2.665a8.173,8.173,0,0,0-.941,1.921l-3.213.213-.21,3.409,3.165.6a8.1,8.1,0,0,0,.693,2.023l-2.122,2.424,2.263,2.557,2.665-1.809a8.181,8.181,0,0,0,1.921.941l.213,3.213,3.409.21.6-3.165a7.983,7.983,0,0,0,2.022-.7l2.424,2.124,2.558-2.263-1.809-2.665a8.078,8.078,0,0,0,.938-1.92l3.215-.214.208-3.408-3.162-.6a8.115,8.115,0,0,0-.7-2.022l2.124-2.424-2.263-2.557-2.665,1.809a8.079,8.079,0,0,0-1.92-.938l-.214-3.215-3.409-.21-.6,3.165A7.992,7.992,0,0,0,295.011,802.463Zm7.56,5.974a4.139,4.139,0,1,1-5.265-2.561A4.138,4.138,0,0,1,302.571,808.436Z"
                transform="translate(-287.474 -798.602)"
                fill="#9b9b9b"
              />
            </g>
            <g
              id="Group_41817"
              data-name="Group 41817"
              transform="translate(0 0)"
            >
              <path
                id="Path_64600"
                data-name="Path 64600"
                d="M220.377,768.479l-2.268-1.092-1.452,2.238,1.918,1.627a6.384,6.384,0,0,0-.307,1.642l-2.374.832.554,2.61,2.508-.207a6.336,6.336,0,0,0,.944,1.378l-1.091,2.267,2.238,1.452,1.628-1.918a6.386,6.386,0,0,0,1.643.307l.832,2.373,2.61-.554-.207-2.508a6.238,6.238,0,0,0,1.376-.946l2.269,1.092,1.452-2.238-1.918-1.628a6.309,6.309,0,0,0,.3-1.641l2.375-.833-.556-2.608-2.506.206a6.333,6.333,0,0,0-.946-1.376l1.092-2.269-2.238-1.452-1.628,1.918a6.31,6.31,0,0,0-1.641-.305l-.833-2.375-2.61.554.207,2.508A6.222,6.222,0,0,0,220.377,768.479Zm6.938,2.917a3.233,3.233,0,1,1-4.5-.828A3.232,3.232,0,0,1,227.315,771.4Z"
                transform="translate(-215.894 -764.471)"
                fill="#9b9b9b"
              />
            </g>
          </g>
          <g
            id="Group_41858"
            data-name="Group 41858"
            transform="translate(12424.712 -9736.661)"
          >
            <g
              id="Group_41822"
              data-name="Group 41822"
              transform="translate(6.494 10.079)"
            >
              <g
                id="Group_41820"
                data-name="Group 41820"
                transform="translate(0.264 0.117)"
              >
                <g id="Group_41819" data-name="Group 41819">
                  <path
                    id="Path_64601"
                    data-name="Path 64601"
                    d="M1067.138,687.771a.723.723,0,0,0-.656-.739c-1.119-.105-2.235-.219-3.339-.357s-2.2-.3-3.264-.509a18.631,18.631,0,0,1-3.049-.853,11.389,11.389,0,0,1-2.623-1.411,18.265,18.265,0,0,1-4.064-4.56c-.148-.225-.3-.442-.446-.672l-.438-.684c-.287-.466-.576-.926-.856-1.4-.566-.941-1.118-1.905-1.668-2.873a2.517,2.517,0,1,0-4.2,2.767c.69.909,1.385,1.818,2.107,2.722.356.453.729.9,1.1,1.352l.568.671c.187.224.389.444.583.666a30.5,30.5,0,0,0,2.545,2.571,16.969,16.969,0,0,0,3.063,2.188,14.432,14.432,0,0,0,3.524,1.331,21.237,21.237,0,0,0,3.555.5c1.168.075,2.318.087,3.459.077s2.275-.045,3.406-.089A.721.721,0,0,0,1067.138,687.771Z"
                    transform="translate(-1042.054 -672.493)"
                    fill="#ea8096"
                  />
                </g>
              </g>
              <g id="Group_41821" data-name="Group 41821">
                <path
                  id="Path_64602"
                  data-name="Path 64602"
                  d="M1044.534,681.52l-3.25-4.729a3.085,3.085,0,0,1,.683-4.342h0a3.29,3.29,0,0,1,4.5.783l3.25,4.729Z"
                  transform="translate(-1040.688 -671.887)"
                  fill={primaryColor}
                />
              </g>
            </g>
            <g
              id="Group_41823"
              data-name="Group 41823"
              transform="translate(21.904 22.264)"
            >
              <rect
                id="Rectangle_20095"
                data-name="Rectangle 20095"
                width="112.801"
                height="133.276"
                fill="#e5e6eb"
              />
            </g>
            <g
              id="Group_41824"
              data-name="Group 41824"
              transform="translate(22.483 22.844)"
            >
              <rect
                id="Rectangle_20096"
                data-name="Rectangle 20096"
                width="132.117"
                height="111.642"
                transform="translate(111.642) rotate(90)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_41825"
              data-name="Group 41825"
              transform="translate(21.904 22.264)"
            >
              <rect
                id="Rectangle_20097"
                data-name="Rectangle 20097"
                width="112.801"
                height="40.356"
                fill="#ffd800"
              />
            </g>
            <g
              id="Group_41830"
              data-name="Group 41830"
              transform="translate(33.024 44.49)"
            >
              <g id="Group_41826" data-name="Group 41826">
                <circle
                  id="Ellipse_1317"
                  data-name="Ellipse 1317"
                  cx="18.131"
                  cy="18.131"
                  r="18.131"
                  fill="#3b4046"
                />
              </g>
              <g
                id="Group_41829"
                data-name="Group 41829"
                transform="translate(10.209 6.336)"
              >
                <g
                  id="Group_41827"
                  data-name="Group 41827"
                  transform="translate(0 12.617)"
                >
                  <path
                    id="Path_64603"
                    data-name="Path 64603"
                    d="M1238.822,948.163a7.923,7.923,0,0,0-7.923,7.923v2.641h15.846v-2.641A7.924,7.924,0,0,0,1238.822,948.163Z"
                    transform="translate(-1230.899 -948.163)"
                    fill="#fff"
                  />
                </g>
                <g
                  id="Group_41828"
                  data-name="Group 41828"
                  transform="translate(2.408)"
                >
                  <path
                    id="Path_64604"
                    data-name="Path 64604"
                    d="M1248.881,893.875a5.515,5.515,0,1,0-5.515-5.515A5.515,5.515,0,0,0,1248.881,893.875Z"
                    transform="translate(-1243.366 -882.844)"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_41835"
              data-name="Group 41835"
              transform="translate(29.715 121.93)"
            >
              <g id="Group_41831" data-name="Group 41831">
                <rect
                  id="Rectangle_20098"
                  data-name="Rectangle 20098"
                  width="97.177"
                  height="2.511"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41832"
                data-name="Group 41832"
                transform="translate(0 7.919)"
              >
                <rect
                  id="Rectangle_20099"
                  data-name="Rectangle 20099"
                  width="97.177"
                  height="2.511"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41833"
                data-name="Group 41833"
                transform="translate(0 15.839)"
              >
                <rect
                  id="Rectangle_20100"
                  data-name="Rectangle 20100"
                  width="97.177"
                  height="2.511"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41834"
                data-name="Group 41834"
                transform="translate(0 23.758)"
              >
                <rect
                  id="Rectangle_20101"
                  data-name="Rectangle 20101"
                  width="97.177"
                  height="2.511"
                  fill="#e5e6eb"
                />
              </g>
            </g>
            <g
              id="Group_41842"
              data-name="Group 41842"
              transform="translate(79.236 68.724)"
            >
              <g
                id="Group_41837"
                data-name="Group 41837"
                transform="translate(34.648 23.828)"
              >
                <g id="Group_41836" data-name="Group 41836">
                  <path
                    id="Path_64605"
                    data-name="Path 64605"
                    d="M1602.1,1116.309l-5.425-5.82a15.717,15.717,0,0,0,5.052-11.613h7.957A23.914,23.914,0,0,1,1602.1,1116.309Z"
                    transform="translate(-1596.672 -1098.876)"
                    fill="#e5e6eb"
                  />
                </g>
              </g>
              <g
                id="Group_41839"
                data-name="Group 41839"
                transform="translate(15.61)"
              >
                <g id="Group_41838" data-name="Group 41838">
                  <path
                    id="Path_64606"
                    data-name="Path 64606"
                    d="M1530.154,999.34H1522.2a15.885,15.885,0,0,0-21.345-14.9l-2.744-7.469a23.842,23.842,0,0,1,32.047,22.373Z"
                    transform="translate(-1498.107 -975.511)"
                    fill="#3b4046"
                  />
                </g>
              </g>
              <g
                id="Group_41841"
                data-name="Group 41841"
                transform="translate(0 1.457)"
              >
                <g id="Group_41840" data-name="Group 41840">
                  <path
                    id="Path_64607"
                    data-name="Path 64607"
                    d="M1441.121,1029.254a23.832,23.832,0,0,1-8.218-46.2l2.744,7.469a15.875,15.875,0,1,0,16.293,26.517l5.426,5.82A23.758,23.758,0,0,1,1441.121,1029.254Z"
                    transform="translate(-1417.292 -983.052)"
                    fill="#ffd800"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_41857"
              data-name="Group 41857"
              transform="translate(0 0)"
            >
              <g
                id="Group_41844"
                data-name="Group 41844"
                transform="translate(0.126 9.481)"
              >
                <path
                  id="Path_64609"
                  data-name="Path 64609"
                  d="M1013.7,668.8h0a7.141,7.141,0,0,1,6.97,8.281l-1.762,11.641c-3.136,1.133-7.577.705-11.181-.343l.014-13.271A5.908,5.908,0,0,1,1013.7,668.8Z"
                  transform="translate(-1007.723 -668.795)"
                  fill="#ffd800"
                />
              </g>
              <g
                id="Group_41845"
                data-name="Group 41845"
                transform="translate(0 9.355)"
              >
                <path
                  id="Path_64610"
                  data-name="Path 64610"
                  d="M1007.075,682.134l-.006,5.03.127.018.005-5.048Zm6.1-13.995h-.069q-.284,0-.564.026l.016.126a5.989,5.989,0,0,1,.616-.025,7.109,7.109,0,0,1,2.793.6l.063-.108A7.289,7.289,0,0,0,1013.171,668.14Zm5.48,2.587a7.3,7.3,0,0,0-1.29-1.2l-.082.1a7.144,7.144,0,0,1,2.954,5.772,7.253,7.253,0,0,1-.093,1.154l-.387,2.555.124.028.388-2.563A7.27,7.27,0,0,0,1018.65,670.726Zm-.274,17.461c-2.835,1.024-6.736.773-10.12-.06l-.016.127a24.588,24.588,0,0,0,5.714.731,13.226,13.226,0,0,0,4.466-.679l.071-.025,1.009-6.666-.126-.014Zm-8.225-19.133-.032-.131a6.091,6.091,0,0,0-1.424,1.13,5.974,5.974,0,0,0-1.612,4.524l0,3.11h.127l0-3.114A5.9,5.9,0,0,1,1010.152,669.054Z"
                  transform="translate(-1007.069 -668.139)"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_41851"
                data-name="Group 41851"
                transform="translate(2.212)"
              >
                <g
                  id="Group_41846"
                  data-name="Group 41846"
                  transform="translate(2.9 7.261)"
                >
                  <path
                    id="Path_64611"
                    data-name="Path 64611"
                    d="M1036.565,657.513l-.185,3.516a2.429,2.429,0,0,1-2.847-.211l.185-3.516Z"
                    transform="translate(-1033.533 -657.302)"
                    fill="#f5bdc8"
                  />
                </g>
                <g
                  id="Group_41847"
                  data-name="Group 41847"
                  transform="translate(3.01 7.657)"
                >
                  <path
                    id="Path_64612"
                    data-name="Path 64612"
                    d="M1036.964,660.244l-.018.4a3.244,3.244,0,0,1-1.51.331l-.089,0a1.8,1.8,0,0,1-1.245-.588l.046-1.03Z"
                    transform="translate(-1034.102 -659.352)"
                    fill="#ea8096"
                  />
                </g>
                <g
                  id="Group_41848"
                  data-name="Group 41848"
                  transform="translate(2.032 2.328)"
                >
                  <path
                    id="Path_64613"
                    data-name="Path 64613"
                    d="M1034.424,632.879l-.25,2.54-.056.564a2.715,2.715,0,0,1-2.771,2.422,1.527,1.527,0,0,1-.422-.071,1.674,1.674,0,0,1-.158-.059l-.033-.014a1.479,1.479,0,0,1-.519-.4,4.567,4.567,0,0,1-.678-1.2,7.838,7.838,0,0,1-.379-1.092,3.51,3.51,0,0,1-.091-1.343l.076-1.738,4.52-.724Z"
                    transform="translate(-1029.039 -631.759)"
                    fill="#f5bdc8"
                  />
                </g>
                <g id="Group_41849" data-name="Group 41849">
                  <path
                    id="Path_64614"
                    data-name="Path 64614"
                    d="M1025.825,627.135s-.013-1.5-.061-2.239v0c-.046-.7-.217-1.361-.712-1.277a1.261,1.261,0,0,1-1.391-.664s0-.008.007-.021a5.049,5.049,0,0,0-.9.147c-1.523.384-1.728,0-1.915-.242a7.618,7.618,0,0,0-.227,2.794.059.059,0,0,1,0,.009,0,0,0,0,1,0,0c.013.067.029.134.046.2a7.754,7.754,0,0,0,.378,1.092,5.219,5.219,0,0,0,.5.973l-.013.236a4.182,4.182,0,0,1-2.7-2.287c-1.113-3.48.773-5.559,3.457-6.085,2.324-.456,3.6,1.687,4.064,3.644A7.108,7.108,0,0,1,1025.825,627.135Z"
                    transform="translate(-1018.52 -619.708)"
                    fill="#050f64"
                  />
                </g>
                <g
                  id="Group_41850"
                  data-name="Group 41850"
                  transform="translate(0.815 4.146)"
                >
                  <circle
                    id="Ellipse_1318"
                    data-name="Ellipse 1318"
                    cx="1.039"
                    cy="1.039"
                    r="1.039"
                    transform="translate(0 2.063) rotate(-83.275)"
                    fill="#f5bdc8"
                  />
                </g>
              </g>
              <g
                id="Group_41856"
                data-name="Group 41856"
                transform="translate(1.38 12.126)"
              >
                <g
                  id="Group_41853"
                  data-name="Group 41853"
                  transform="translate(0.479 0.358)"
                >
                  <g id="Group_41852" data-name="Group 41852">
                    <path
                      id="Path_64615"
                      data-name="Path 64615"
                      d="M1041.615,699.9a.723.723,0,0,0-.647-.747c-1.118-.119-2.232-.246-3.334-.4s-2.2-.323-3.258-.549a18.629,18.629,0,0,1-3.038-.891,11.393,11.393,0,0,1-2.6-1.443,18.263,18.263,0,0,1-4.007-4.609c-.146-.227-.3-.445-.438-.677l-.43-.689c-.281-.469-.564-.933-.839-1.412-.554-.948-1.094-1.919-1.632-2.894a2.517,2.517,0,1,0-4.235,2.715c.679.918,1.363,1.835,2.073,2.748.35.457.718.911,1.08,1.365l.56.678c.184.226.384.449.574.673a30.522,30.522,0,0,0,2.513,2.6,16.95,16.95,0,0,0,3.036,2.226,14.436,14.436,0,0,0,3.508,1.374,21.2,21.2,0,0,0,3.548.548c1.167.09,2.316.115,3.458.119s2.276-.017,3.406-.047A.722.722,0,0,0,1041.615,699.9Z"
                      transform="translate(-1016.691 -684.343)"
                      fill="#f5bdc8"
                    />
                  </g>
                </g>
                <g
                  id="Group_41854"
                  data-name="Group 41854"
                  transform="translate(0.124 0.126)"
                >
                  <path
                    id="Path_64616"
                    data-name="Path 64616"
                    d="M1018.616,692.782l-3.191-4.769a3.085,3.085,0,0,1,.737-4.334h0a3.29,3.29,0,0,1,4.487.838l3.191,4.769Z"
                    transform="translate(-1014.851 -683.14)"
                    fill={primaryColor}
                  />
                </g>
                <g id="Group_41855" data-name="Group 41855">
                  <path
                    id="Path_64617"
                    data-name="Path 64617"
                    d="M1018.091,682.544a3.5,3.5,0,0,0-1.666.1l.035.12a3.275,3.275,0,0,1,3.673,1.227l.281.42.1-.084-.272-.407A3.252,3.252,0,0,0,1018.091,682.544Zm5.232,6.216-4.256,2.848.073.1,4.358-2.916-1.825-2.728-.1.073Zm-8.186-5.359a3.216,3.216,0,0,0-.6,3.684l.118-.047a3.079,3.079,0,0,1,.557-3.533Zm2.631,8.588.108-.066-1.538-2.3-.11.064Z"
                    transform="translate(-1014.211 -682.487)"
                    fill="#fff"
                  />
                </g>
              </g>
            </g>
          </g>
          <g
            id="Group_41884"
            data-name="Group 41884"
            transform="translate(12277.068 -9730.219)"
          >
            <g
              id="Group_41860"
              data-name="Group 41860"
              transform="translate(1.725 17.737)"
            >
              <g id="Group_41859" data-name="Group 41859">
                <path
                  id="Path_64618"
                  data-name="Path 64618"
                  d="M259.1,812.965l-7.48-7.48,60.594-60.595,7.481,7.48Zm-4.868-7.481,4.868,4.868,57.982-57.982-4.868-4.868Z"
                  transform="translate(-251.617 -744.89)"
                  fill="#3b4046"
                />
              </g>
            </g>
            <g
              id="Group_41873"
              data-name="Group 41873"
              transform="translate(54.307 0)"
            >
              <g
                id="Group_41862"
                data-name="Group 41862"
                transform="translate(32.512 32.512)"
              >
                <g id="Group_41861" data-name="Group 41861">
                  <circle
                    id="Ellipse_1319"
                    data-name="Ellipse 1319"
                    cx="7.8"
                    cy="7.8"
                    r="7.8"
                    fill="#ffd800"
                  />
                </g>
              </g>
              <g
                id="Group_41864"
                data-name="Group 41864"
                transform="translate(0.689 0.689)"
              >
                <g id="Group_41863" data-name="Group 41863">
                  <path
                    id="Path_64619"
                    data-name="Path 64619"
                    d="M542.361,688.123l-14.949-20.755,10.74-10.74,20.754,14.949Z"
                    transform="translate(-527.412 -656.628)"
                    fill="#3b4046"
                  />
                </g>
              </g>
              <g
                id="Group_41866"
                data-name="Group 41866"
                transform="translate(13.759 13.759)"
              >
                <g id="Group_41865" data-name="Group 41865">
                  <path
                    id="Path_64620"
                    data-name="Path 64620"
                    d="M600.717,764.474h0a19.258,19.258,0,0,1,0-27.235l7.307-7.307a19.258,19.258,0,0,1,27.235,0h0Z"
                    transform="translate(-595.076 -724.291)"
                    fill="#ffd800"
                  />
                </g>
              </g>
              <g
                id="Group_41868"
                data-name="Group 41868"
                transform="translate(8.058 0.689)"
                opacity="0.5"
              >
                <g id="Group_41867" data-name="Group 41867">
                  <path
                    id="Path_64621"
                    data-name="Path 64621"
                    d="M611.445,675.338l-3.374,3.374c-5.847-5.847-15.6-7.685-22.7-4.441-.07.026.065-.03,0,0h0L565.561,660l3.374-3.374,20.686,14.9A19.262,19.262,0,0,1,611.445,675.338Z"
                    transform="translate(-565.561 -656.628)"
                    fill="#3b4046"
                  />
                </g>
              </g>
              <g
                id="Group_41870"
                data-name="Group 41870"
                transform="translate(19.4 19.399)"
              >
                <g id="Group_41869" data-name="Group 41869">
                  <path
                    id="Path_64622"
                    data-name="Path 64622"
                    d="M624.279,788.036h0l34.543-34.542h0a5.149,5.149,0,0,1,0,7.282l-27.261,27.261A5.149,5.149,0,0,1,624.279,788.036Z"
                    transform="translate(-624.279 -753.494)"
                    fill="#3b4046"
                  />
                </g>
              </g>
              <g id="Group_41872" data-name="Group 41872">
                <g id="Group_41871" data-name="Group 41871">
                  <path
                    id="Path_64623"
                    data-name="Path 64623"
                    d="M526.528,662.493l-2.685-3.991,5.443-5.443,3.991,2.685Z"
                    transform="translate(-523.843 -653.059)"
                    fill="#3b4046"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_41875"
              data-name="Group 41875"
              transform="translate(3.674 74.277)"
            >
              <g id="Group_41874" data-name="Group 41874">
                <path
                  id="Path_64624"
                  data-name="Path 64624"
                  d="M327.614,1128.034l-65.909-83.891,8.319-6.536,65.909,83.891ZM264.3,1044.455l63.627,80.986,5.413-4.253L269.712,1040.2Z"
                  transform="translate(-261.705 -1037.607)"
                  fill="#3b4046"
                />
              </g>
            </g>
            <g
              id="Group_41877"
              data-name="Group 41877"
              transform="translate(0 67.77)"
            >
              <g id="Group_41876" data-name="Group 41876">
                <circle
                  id="Ellipse_1320"
                  data-name="Ellipse 1320"
                  cx="10.564"
                  cy="10.564"
                  r="10.564"
                  fill="#3b4046"
                />
              </g>
            </g>
            <g
              id="Group_41879"
              data-name="Group 41879"
              transform="translate(4.97 72.74)"
            >
              <g id="Group_41878" data-name="Group 41878">
                <circle
                  id="Ellipse_1321"
                  data-name="Ellipse 1321"
                  cx="5.593"
                  cy="5.593"
                  r="5.593"
                  fill="#ffd800"
                />
              </g>
            </g>
            <g
              id="Group_41881"
              data-name="Group 41881"
              transform="translate(36.204 156.021)"
            >
              <g id="Group_41880" data-name="Group 41880">
                <rect
                  id="Rectangle_20102"
                  data-name="Rectangle 20102"
                  width="55.072"
                  height="9.339"
                  fill="#ffd800"
                />
              </g>
            </g>
            <g
              id="Group_41883"
              data-name="Group 41883"
              transform="translate(49.286 146.683)"
            >
              <g id="Group_41882" data-name="Group 41882">
                <path
                  id="Path_64625"
                  data-name="Path 64625"
                  d="M526.76,1421.809H497.851l3.142-9.339h22.625Z"
                  transform="translate(-497.851 -1412.47)"
                  fill="#ffd800"
                />
              </g>
            </g>
          </g>
          <g
            id="Group_41923"
            data-name="Group 41923"
            transform="translate(12283.561 -9767.38)"
          >
            <g
              id="Group_41886"
              data-name="Group 41886"
              transform="translate(24.978)"
            >
              <g id="Group_41885" data-name="Group 41885">
                <path
                  id="Path_64626"
                  data-name="Path 64626"
                  d="M407.165,471l-1.031,0a.524.524,0,0,1-.522-.526l.035-9.28a.524.524,0,0,1,.526-.522l1.031,0a.524.524,0,0,1,.522.526l-.035,9.28A.524.524,0,0,1,407.165,471Z"
                  transform="translate(-405.612 -460.664)"
                  fill="#ffd800"
                />
              </g>
            </g>
            <g
              id="Group_41888"
              data-name="Group 41888"
              transform="translate(7.14 7.049)"
            >
              <g id="Group_41887" data-name="Group 41887">
                <path
                  id="Path_64627"
                  data-name="Path 64627"
                  d="M321.422,504.643l-.732.727a.524.524,0,0,1-.741,0l-6.537-6.587a.524.524,0,0,1,0-.741l.732-.727a.524.524,0,0,1,.741,0l6.537,6.587A.524.524,0,0,1,321.422,504.643Z"
                  transform="translate(-313.26 -497.161)"
                  fill="#ffd800"
                />
              </g>
            </g>
            <g
              id="Group_41890"
              data-name="Group 41890"
              transform="translate(0 24.881)"
            >
              <g id="Group_41889" data-name="Group 41889">
                <path
                  id="Path_64628"
                  data-name="Path 64628"
                  d="M286.628,590.041l0,1.032a.524.524,0,0,1-.526.522l-9.28-.035a.524.524,0,0,1-.522-.526l0-1.031a.524.524,0,0,1,.526-.522l9.28.035A.524.524,0,0,1,286.628,590.041Z"
                  transform="translate(-276.296 -589.48)"
                  fill="#ffd800"
                />
              </g>
            </g>
            <g
              id="Group_41892"
              data-name="Group 41892"
              transform="translate(7.05 36.517)"
            >
              <g id="Group_41891" data-name="Group 41891">
                <path
                  id="Path_64629"
                  data-name="Path 64629"
                  d="M320.276,649.875l.727.732a.524.524,0,0,1,0,.741l-6.587,6.537a.524.524,0,0,1-.741,0l-.727-.732a.524.524,0,0,1,0-.741l6.587-6.537A.524.524,0,0,1,320.276,649.875Z"
                  transform="translate(-312.794 -649.72)"
                  fill="#ffd800"
                />
              </g>
            </g>
            <g
              id="Group_41894"
              data-name="Group 41894"
              transform="translate(36.517 36.563)"
            >
              <g id="Group_41893" data-name="Group 41893">
                <path
                  id="Path_64630"
                  data-name="Path 64630"
                  d="M465.507,650.836l.732-.727a.524.524,0,0,1,.741,0l6.537,6.587a.524.524,0,0,1,0,.741l-.732.727a.524.524,0,0,1-.741,0l-6.537-6.587A.524.524,0,0,1,465.507,650.836Z"
                  transform="translate(-465.352 -649.958)"
                  fill="#ffd800"
                />
              </g>
            </g>
            <g
              id="Group_41896"
              data-name="Group 41896"
              transform="translate(41.642 24.978)"
            >
              <g id="Group_41895" data-name="Group 41895">
                <path
                  id="Path_64631"
                  data-name="Path 64631"
                  d="M491.886,591.533l0-1.031a.524.524,0,0,1,.526-.522l9.28.035a.524.524,0,0,1,.522.526l0,1.032a.524.524,0,0,1-.526.522l-9.28-.035A.524.524,0,0,1,491.886,591.533Z"
                  transform="translate(-491.886 -589.98)"
                  fill="#ffd800"
                />
              </g>
            </g>
            <g
              id="Group_41898"
              data-name="Group 41898"
              transform="translate(36.563 7.14)"
            >
              <g id="Group_41897" data-name="Group 41897">
                <path
                  id="Path_64632"
                  data-name="Path 64632"
                  d="M466.469,505.79l-.727-.732a.524.524,0,0,1,0-.741l6.587-6.537a.524.524,0,0,1,.741,0l.727.732a.524.524,0,0,1,0,.741l-6.587,6.537A.524.524,0,0,1,466.469,505.79Z"
                  transform="translate(-465.59 -497.628)"
                  fill="#ffd800"
                />
              </g>
            </g>
            <g
              id="Group_41922"
              data-name="Group 41922"
              transform="translate(12.42 12.449)"
            >
              <g id="Group_41919" data-name="Group 41919">
                <g id="Group_41900" data-name="Group 41900">
                  <g id="Group_41899" data-name="Group 41899">
                    <path
                      id="Path_64633"
                      data-name="Path 64633"
                      d="M367.67,538.7a13.493,13.493,0,0,1-4.223,9.771,8.636,8.636,0,0,0-1.992,2.862,8.756,8.756,0,0,0-.707,3.416,4.935,4.935,0,0,1-4.957,4.92l-3.469-.013a4.938,4.938,0,0,1-4.92-4.957,8.806,8.806,0,0,0-2.7-6.343,13.518,13.518,0,0,1-2.961-15.138c.125-.284.261-.563.4-.836A13.531,13.531,0,0,1,367.67,538.7Z"
                      transform="translate(-340.598 -525.116)"
                      fill="#ffd800"
                    />
                  </g>
                </g>
                <g
                  id="Group_41902"
                  data-name="Group 41902"
                  transform="translate(0 8.105)"
                >
                  <g id="Group_41901" data-name="Group 41901">
                    <path
                      id="Path_64634"
                      data-name="Path 64634"
                      d="M359.513,591.859a4.932,4.932,0,0,1-3.724,1.672l-3.469-.013a4.938,4.938,0,0,1-4.92-4.957,8.806,8.806,0,0,0-2.7-6.343,13.518,13.518,0,0,1-2.961-15.138c.845,5.034,2.95,11.989,8.186,16.679C349.926,583.759,348.461,592.817,359.513,591.859Z"
                      transform="translate(-340.598 -567.08)"
                      fill="#dca000"
                    />
                  </g>
                </g>
                <g
                  id="Group_41904"
                  data-name="Group 41904"
                  transform="translate(15.602 2.763)"
                >
                  <g id="Group_41903" data-name="Group 41903">
                    <path
                      id="Path_64635"
                      data-name="Path 64635"
                      d="M428.33,542.915c2.354,2.768,3.289,5.839,2.09,6.859s-4.08-.4-6.434-3.165-3.289-5.839-2.09-6.859S425.976,540.147,428.33,542.915Z"
                      transform="translate(-421.374 -539.419)"
                      fill="#fff"
                    />
                  </g>
                </g>
                <g
                  id="Group_41906"
                  data-name="Group 41906"
                  transform="translate(6.894 33.111)"
                >
                  <g id="Group_41905" data-name="Group 41905">
                    <path
                      id="Path_64636"
                      data-name="Path 64636"
                      d="M389.417,697.887a1.3,1.3,0,0,1-.386.92,1.314,1.314,0,0,1-.213.171,1.3,1.3,0,0,1-.71.208l-10.517-.04a1.3,1.3,0,1,1,.01-2.609l10.517.04A1.3,1.3,0,0,1,389.417,697.887Z"
                      transform="translate(-376.291 -696.538)"
                      fill="#3b4046"
                    />
                  </g>
                </g>
                <g
                  id="Group_41908"
                  data-name="Group 41908"
                  transform="translate(7.515 35.679)"
                >
                  <g id="Group_41907" data-name="Group 41907">
                    <path
                      id="Path_64637"
                      data-name="Path 64637"
                      d="M391.371,711.181a1.3,1.3,0,0,1-.386.921,1.313,1.313,0,0,1-.845.376l-.078,0-9.255-.035-.078,0a1.3,1.3,0,0,1-1.221-1.306,1.3,1.3,0,0,1,1.309-1.3l9.255.035A1.3,1.3,0,0,1,391.371,711.181Z"
                      transform="translate(-379.507 -709.837)"
                      fill="#3b4046"
                    />
                  </g>
                </g>
                <g
                  id="Group_41910"
                  data-name="Group 41910"
                  transform="translate(10.221 39.558)"
                >
                  <g id="Group_41909" data-name="Group 41909">
                    <path
                      id="Path_64638"
                      data-name="Path 64638"
                      d="M397.957,734.2l-2.423-.009a2.028,2.028,0,0,1-2.02-2.036l.008-2.24,6.479.025-.008,2.24A2.028,2.028,0,0,1,397.957,734.2Z"
                      transform="translate(-393.514 -729.916)"
                      fill="#3b4046"
                    />
                  </g>
                </g>
                <g
                  id="Group_41912"
                  data-name="Group 41912"
                  transform="translate(8.673 38.284)"
                >
                  <g id="Group_41911" data-name="Group 41911">
                    <path
                      id="Path_64639"
                      data-name="Path 64639"
                      d="M395.091,724.656a1.3,1.3,0,0,1-1.309,1.3l-6.984-.026a1.3,1.3,0,1,1,.01-2.608l6.984.026A1.305,1.305,0,0,1,395.091,724.656Z"
                      transform="translate(-385.499 -723.32)"
                      fill="#3b4046"
                    />
                  </g>
                </g>
                <g
                  id="Group_41914"
                  data-name="Group 41914"
                  transform="translate(7.484 35.506)"
                >
                  <g id="Group_41913" data-name="Group 41913">
                    <path
                      id="Path_64640"
                      data-name="Path 64640"
                      d="M391.283,708.985a1.3,1.3,0,0,1-.71.208l-10.517-.04a1.3,1.3,0,0,1-.709-.213Z"
                      transform="translate(-379.346 -708.94)"
                      fill="#050f64"
                    />
                  </g>
                </g>
                <g
                  id="Group_41916"
                  data-name="Group 41916"
                  transform="translate(8.101 38.072)"
                >
                  <g id="Group_41915" data-name="Group 41915">
                    <path
                      id="Path_64641"
                      data-name="Path 64641"
                      d="M393.223,722.265l-.636.208-9.412-.036a1.291,1.291,0,0,1-.635-.213Z"
                      transform="translate(-382.54 -722.224)"
                      fill="#050f64"
                    />
                  </g>
                </g>
                <g
                  id="Group_41918"
                  data-name="Group 41918"
                  transform="translate(9.264 40.68)"
                >
                  <g id="Group_41917" data-name="Group 41917">
                    <path
                      id="Path_64642"
                      data-name="Path 64642"
                      d="M396.96,735.758a1.294,1.294,0,0,1-.71.207l-6.984-.026a1.294,1.294,0,0,1-.708-.212Z"
                      transform="translate(-388.558 -735.726)"
                      fill="#050f64"
                    />
                  </g>
                </g>
              </g>
              <g
                id="Group_41921"
                data-name="Group 41921"
                transform="translate(7.616 12.354)"
              >
                <g id="Group_41920" data-name="Group 41920">
                  <path
                    id="Path_64643"
                    data-name="Path 64643"
                    d="M390.965,589.757a2.623,2.623,0,0,0-1.916-.678,2.322,2.322,0,0,0-1.655.764,3.568,3.568,0,0,0-.737,1.91c-.073.516-.108,1.616-.122,2.9-.181-.008-.992-.008-1.173,0-.013-1.287-.048-2.387-.122-2.9a3.568,3.568,0,0,0-.737-1.91,2.323,2.323,0,0,0-1.655-.764,2.622,2.622,0,0,0-1.915.678,3.142,3.142,0,0,0-.648,3.469,4.256,4.256,0,0,0,2.557,2.282,5.943,5.943,0,0,0,1.341.3c0,2.717-.061,13.963-.062,14.013l1.185.025c0-.2.066-11.328.062-14,.188-.008.971-.008,1.16,0,0,2.674.058,13.8.062,14l1.185-.025c0-.05-.065-11.3-.062-14.013a5.929,5.929,0,0,0,1.341-.3,4.256,4.256,0,0,0,2.557-2.282A3.142,3.142,0,0,0,390.965,589.757Zm-7.727,4.633a3.117,3.117,0,0,1-1.859-1.623,1.965,1.965,0,0,1,.364-2.143,1.441,1.441,0,0,1,.972-.363l.075,0a1.15,1.15,0,0,1,.823.363,2.541,2.541,0,0,1,.454,1.295c.066.464.1,1.482.11,2.692A4.677,4.677,0,0,1,383.237,594.39Zm7.282-1.623a3.115,3.115,0,0,1-1.859,1.623,4.676,4.676,0,0,1-.94.222c.012-1.209.045-2.227.111-2.692a2.539,2.539,0,0,1,.454-1.295,1.15,1.15,0,0,1,.823-.363l.075,0a1.441,1.441,0,0,1,.972.363A1.965,1.965,0,0,1,390.519,592.767Z"
                    transform="translate(-380.029 -589.076)"
                    fill="#dca000"
                  />
                </g>
              </g>
            </g>
          </g>
          <g
            id="Group_41940"
            data-name="Group 41940"
            transform="translate(12375.966 -9577.806)"
          >
            <g
              id="Group_41931"
              data-name="Group 41931"
              transform="translate(36.263 0)"
            >
              <g id="Group_41924" data-name="Group 41924">
                <rect
                  id="Rectangle_20103"
                  data-name="Rectangle 20103"
                  width="84.04"
                  height="12.947"
                  fill="#ffbd00"
                />
              </g>
              <g
                id="Group_41925"
                data-name="Group 41925"
                transform="translate(11.513)"
              >
                <rect
                  id="Rectangle_20104"
                  data-name="Rectangle 20104"
                  width="0.573"
                  height="3.801"
                  fill="#dca000"
                />
              </g>
              <g
                id="Group_41926"
                data-name="Group 41926"
                transform="translate(23.603)"
              >
                <rect
                  id="Rectangle_20105"
                  data-name="Rectangle 20105"
                  width="0.573"
                  height="3.801"
                  fill="#dca000"
                />
              </g>
              <g
                id="Group_41927"
                data-name="Group 41927"
                transform="translate(35.69)"
              >
                <rect
                  id="Rectangle_20106"
                  data-name="Rectangle 20106"
                  width="0.573"
                  height="3.801"
                  fill="#dca000"
                />
              </g>
              <g
                id="Group_41928"
                data-name="Group 41928"
                transform="translate(47.778)"
              >
                <rect
                  id="Rectangle_20107"
                  data-name="Rectangle 20107"
                  width="0.573"
                  height="3.801"
                  fill="#dca000"
                />
              </g>
              <g
                id="Group_41929"
                data-name="Group 41929"
                transform="translate(59.865)"
              >
                <rect
                  id="Rectangle_20108"
                  data-name="Rectangle 20108"
                  width="0.573"
                  height="3.801"
                  fill="#dca000"
                />
              </g>
              <g
                id="Group_41930"
                data-name="Group 41930"
                transform="translate(71.953)"
              >
                <rect
                  id="Rectangle_20109"
                  data-name="Rectangle 20109"
                  width="0.573"
                  height="3.801"
                  fill="#dca000"
                />
              </g>
            </g>
            <g
              id="Group_41939"
              data-name="Group 41939"
              transform="translate(0 0)"
            >
              <g id="Group_41932" data-name="Group 41932">
                <rect
                  id="Rectangle_20110"
                  data-name="Rectangle 20110"
                  width="84.04"
                  height="12.947"
                  fill="#ffbd00"
                />
              </g>
              <g
                id="Group_41933"
                data-name="Group 41933"
                transform="translate(11.514)"
              >
                <rect
                  id="Rectangle_20111"
                  data-name="Rectangle 20111"
                  width="0.573"
                  height="3.801"
                  fill="#dca000"
                />
              </g>
              <g
                id="Group_41934"
                data-name="Group 41934"
                transform="translate(23.602)"
              >
                <rect
                  id="Rectangle_20112"
                  data-name="Rectangle 20112"
                  width="0.573"
                  height="3.801"
                  fill="#dca000"
                />
              </g>
              <g
                id="Group_41935"
                data-name="Group 41935"
                transform="translate(35.69)"
              >
                <rect
                  id="Rectangle_20113"
                  data-name="Rectangle 20113"
                  width="0.573"
                  height="3.801"
                  fill="#dca000"
                />
              </g>
              <g
                id="Group_41936"
                data-name="Group 41936"
                transform="translate(47.776)"
              >
                <rect
                  id="Rectangle_20114"
                  data-name="Rectangle 20114"
                  width="0.573"
                  height="3.801"
                  fill="#dca000"
                />
              </g>
              <g
                id="Group_41937"
                data-name="Group 41937"
                transform="translate(59.866)"
              >
                <rect
                  id="Rectangle_20115"
                  data-name="Rectangle 20115"
                  width="0.573"
                  height="3.801"
                  fill="#dca000"
                />
              </g>
              <g
                id="Group_41938"
                data-name="Group 41938"
                transform="translate(71.953)"
              >
                <rect
                  id="Rectangle_20116"
                  data-name="Rectangle 20116"
                  width="0.573"
                  height="3.801"
                  fill="#dca000"
                />
              </g>
            </g>
          </g>
          <g
            id="Group_41965"
            data-name="Group 41965"
            transform="translate(12469.931 -9638.863)"
          >
            <g
              id="Group_41941"
              data-name="Group 41941"
              transform="translate(15.306 71.836)"
            >
              <path
                id="Path_64644"
                data-name="Path 64644"
                d="M1320.434,1500.11h7.148a1.1,1.1,0,0,0-.2-.67,1.131,1.131,0,0,0-.716-.381,6.836,6.836,0,0,0-.83-.048,4.393,4.393,0,0,1-1.939-.562,6.568,6.568,0,0,0-.931-.508l-1.948.051a2.232,2.232,0,0,0-.521,1.05A3.889,3.889,0,0,0,1320.434,1500.11Z"
                transform="translate(-1320.422 -1497.941)"
                fill="#050f64"
              />
            </g>
            <g
              id="Group_41942"
              data-name="Group 41942"
              transform="translate(15.352 69.572)"
            >
              <path
                id="Path_64645"
                data-name="Path 64645"
                d="M1320.66,1486.429l.547,2.107,1.949-.052-.116-2.264Z"
                transform="translate(-1320.66 -1486.22)"
                fill="#f5bdc8"
              />
            </g>
            <g
              id="Group_41943"
              data-name="Group 41943"
              transform="translate(0.129 32.03)"
            >
              <path
                id="Path_64646"
                data-name="Path 64646"
                d="M1260.1,1311.588a17.76,17.76,0,0,0-.361-4.048c-.948-4.589-2.653-13.427-2.654-13.429-.264-1.9-1.847-2.462-3.752-2.2-1.107.153-11.5,2.305-11.493,2.4l2.266,35.226,2.891-.1,3.1-27.75,4.754,8.715,0,.011,2.012,19.2,2.778-.19Z"
                transform="translate(-1241.845 -1291.853)"
                fill="#3b4046"
              />
            </g>
            <g
              id="Group_41944"
              data-name="Group 41944"
              transform="translate(2.271 71.836)"
            >
              <path
                id="Path_64647"
                data-name="Path 64647"
                d="M1252.947,1500.109h7.148a1.1,1.1,0,0,0-.2-.67,1.13,1.13,0,0,0-.716-.381,6.86,6.86,0,0,0-.83-.048,4.391,4.391,0,0,1-1.939-.562,6.551,6.551,0,0,0-.931-.508l-1.948.051a2.233,2.233,0,0,0-.52,1.05A3.962,3.962,0,0,0,1252.947,1500.109Z"
                transform="translate(-1252.937 -1497.94)"
                fill="#050f64"
              />
            </g>
            <g
              id="Group_41945"
              data-name="Group 41945"
              transform="translate(2.631 69.628)"
            >
              <path
                id="Path_64648"
                data-name="Path 64648"
                d="M1254.8,1486.595l.232,2.175,1.949-.052.3-2.208Z"
                transform="translate(-1254.8 -1486.51)"
                fill="#f5bdc8"
              />
            </g>
            <g
              id="Group_41949"
              data-name="Group 41949"
              transform="translate(8.796 7.265)"
            >
              <g
                id="Group_41947"
                data-name="Group 41947"
                transform="translate(0.119)"
              >
                <g id="Group_41946" data-name="Group 41946">
                  <path
                    id="Path_64649"
                    data-name="Path 64649"
                    d="M1309.775,1163.653a.714.714,0,0,0-.824.484,17.288,17.288,0,0,1-1.036,2.844,9.3,9.3,0,0,1-1.569,2.373,5.582,5.582,0,0,1-2.128,1.448,5.839,5.839,0,0,1-1.225.3,7.206,7.206,0,0,1-1.3.051,11.533,11.533,0,0,1-2.7-.49,20.558,20.558,0,0,1-2.7-1.033c-.893-.41-1.775-.87-2.644-1.369s-1.728-1.03-2.576-1.588a2.226,2.226,0,0,0-1.8-.232,2.668,2.668,0,0,0-1.552,1.191h0a2.524,2.524,0,0,0-.3,1.94,2.306,2.306,0,0,0,1.209,1.5c1,.471,2.013.917,3.051,1.329s2.1.789,3.187,1.112a24.355,24.355,0,0,0,3.37.759,14.872,14.872,0,0,0,3.591.118,10.266,10.266,0,0,0,1.839-.347,8.724,8.724,0,0,0,1.764-.728,8.179,8.179,0,0,0,2.754-2.506,11.431,11.431,0,0,0,1.5-3.145,18.961,18.961,0,0,0,.688-3.247A.7.7,0,0,0,1309.775,1163.653Z"
                    transform="translate(-1287.335 -1163.642)"
                    fill="#f5bdc8"
                  />
                </g>
              </g>
              <g
                id="Group_41948"
                data-name="Group 41948"
                transform="translate(0 1.968)"
              >
                <path
                  id="Path_64650"
                  data-name="Path 64650"
                  d="M1294.659,1183.694l-5.885-3.034a3.559,3.559,0,0,1-1.676-4.787h0a3.8,3.8,0,0,1,5-1.659l5.885,3.034Z"
                  transform="translate(-1286.719 -1173.83)"
                  fill="#fff"
                />
              </g>
            </g>
            <g
              id="Group_41950"
              data-name="Group 41950"
              transform="translate(0.128 9.204)"
            >
              <path
                id="Path_64651"
                data-name="Path 64651"
                d="M1249.712,1173.708h0a6.692,6.692,0,0,1,7.285,6.638l.089,18.42c-6.234,3.022-9.753,2.013-15.245.206l.393-17.306A8.208,8.208,0,0,1,1249.712,1173.708Z"
                transform="translate(-1241.842 -1173.681)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_41951"
              data-name="Group 41951"
              transform="translate(0 9.079)"
            >
              <path
                id="Path_64652"
                data-name="Path 64652"
                d="M1256.588,1179.822a6.828,6.828,0,0,0-6.809-6.791c-.2,0-.41.009-.614.027-.1.009-.2.02-.3.032q-.012.065-.027.131c.111-.015.223-.027.336-.037q.3-.027.6-.027a6.693,6.693,0,0,1,6.682,6.664l.032,6.725h.127Zm-8.468,20.3.009.127c.363.03.727.045,1.093.045a13.36,13.36,0,0,0,2.47-.234l-.043-.12A13.17,13.17,0,0,1,1248.12,1200.122Zm-6.548-18.983-.095,4.2h.127l.095-4.195a8.186,8.186,0,0,1,2.327-5.511c-.031-.03-.061-.059-.091-.089A8.316,8.316,0,0,0,1241.573,1181.139Zm-.178,13.432-.126-.018-.091,3.986.089.029c.678.223,1.322.432,1.941.621,0-.044,0-.087,0-.13-.611-.188-1.242-.394-1.9-.611Zm15.251-2.892h-.126l.032,6.562q-.633.307-1.23.559l.031.125q.615-.26,1.255-.57l.072-.035Z"
                transform="translate(-1241.178 -1173.031)"
                fill="#84a9ff"
              />
            </g>
            <g
              id="Group_41955"
              data-name="Group 41955"
              transform="translate(5.861 1.439)"
            >
              <g
                id="Group_41952"
                data-name="Group 41952"
                transform="translate(0.825 5.599)"
              >
                <path
                  id="Path_64653"
                  data-name="Path 64653"
                  d="M1279.032,1162.555l-.141,4.76a2.641,2.641,0,0,1-3.1-.092l.142-4.76Z"
                  transform="translate(-1275.789 -1162.463)"
                  fill="#f5bdc8"
                />
              </g>
              <g
                id="Group_41953"
                data-name="Group 41953"
                transform="translate(0.928 5.599)"
              >
                <path
                  id="Path_64654"
                  data-name="Path 64654"
                  d="M1279.465,1162.554l-.064,2.153a2.511,2.511,0,0,1-.7.139q-.117.006-.234,0a2.791,2.791,0,0,1-2.142-1.109l.038-1.278Z"
                  transform="translate(-1276.326 -1162.462)"
                  fill="#ea8096"
                />
              </g>
              <g id="Group_41954" data-name="Group 41954">
                <path
                  id="Path_64655"
                  data-name="Path 64655"
                  d="M1277.082,1136.3l-.189,2.791a2.211,2.211,0,0,1-2.087,2.058h0a2.459,2.459,0,0,1-2.38-1.441,18.727,18.727,0,0,1-.75-2.07,3.365,3.365,0,0,1,.817-3.392,2.711,2.711,0,0,1,4.59,2.054Z"
                  transform="translate(-1271.52 -1133.475)"
                  fill="#f5bdc8"
                />
              </g>
            </g>
            <g
              id="Group_41960"
              data-name="Group 41960"
              transform="translate(0.886 12.369)"
            >
              <g
                id="Group_41957"
                data-name="Group 41957"
                transform="translate(1.24 0.194)"
              >
                <g id="Group_41956" data-name="Group 41956">
                  <path
                    id="Path_64656"
                    data-name="Path 64656"
                    d="M1257.9,1219.432a.757.757,0,0,0,.2-.926,14.564,14.564,0,0,1-1.194-2.821,23.482,23.482,0,0,1-.712-3.025c-.039-.258-.088-.511-.12-.77l-.1-.773-.077-.777c-.028-.258-.038-.52-.058-.779l-.027-.389-.015-.391c-.009-.261-.022-.52-.028-.781,0-.523-.017-1.042,0-1.565a57.067,57.067,0,0,1,1.746-12.417,2.183,2.183,0,0,0,.048-.486,2.294,2.294,0,0,0-.048-.473,2.365,2.365,0,0,0-.378-.866,2.643,2.643,0,0,0-1.649-1.074h0a2.486,2.486,0,0,0-1.925.391,2.448,2.448,0,0,0-.674.711,2.315,2.315,0,0,0-.22.453,2.478,2.478,0,0,0-.114.507,61.1,61.1,0,0,0-.017,13.428c.058.558.152,1.116.231,1.671.045.278.1.555.146.832l.075.415.086.414c.06.276.11.552.178.826l.2.822.223.817c.073.272.163.541.244.811a25.55,25.55,0,0,0,1.226,3.163,16.135,16.135,0,0,0,1.763,2.941A.675.675,0,0,0,1257.9,1219.432Z"
                    transform="translate(-1252.183 -1191.067)"
                    fill="#f5bdc8"
                  />
                </g>
              </g>
              <g
                id="Group_41958"
                data-name="Group 41958"
                transform="translate(0.049 0.126)"
              >
                <path
                  id="Path_64657"
                  data-name="Path 64657"
                  d="M1246.02,1200.663l.627-6.591a3.559,3.559,0,0,1,3.82-3.336h0a3.8,3.8,0,0,1,3.4,4.023l-.627,6.591Z"
                  transform="translate(-1246.02 -1190.72)"
                  fill="#fff"
                />
              </g>
              <g id="Group_41959" data-name="Group 41959">
                <path
                  id="Path_64658"
                  data-name="Path 64658"
                  d="M1250.271,1190.081c-.115-.011-.231-.016-.345-.016a3.556,3.556,0,0,0-2.923,1.56l.107.066a3.41,3.41,0,0,1,3.148-1.484,3.8,3.8,0,0,1,2.461,1.27l.106-.072A3.94,3.94,0,0,0,1250.271,1190.081Zm3.259,5.513-.317,3.337h.127l.316-3.317Zm-.5,5.227-3.915-.373-.008.127,4.038.384.06-.632-.126-.021Zm-6.907-5.314-.362,3.812.125.016.364-3.828Z"
                  transform="translate(-1245.764 -1190.065)"
                  fill="#84a9ff"
                />
              </g>
            </g>
            <g
              id="Group_41963"
              data-name="Group 41963"
              transform="translate(4.326 0)"
            >
              <g
                id="Group_41961"
                data-name="Group 41961"
                transform="translate(6.533 2.334)"
              >
                <path
                  id="Path_64659"
                  data-name="Path 64659"
                  d="M1297.4,1138.545a5.222,5.222,0,0,1,.487,2.638,8.408,8.408,0,0,0,.019-3.073Z"
                  transform="translate(-1297.4 -1138.111)"
                  fill="#050f64"
                />
              </g>
              <g id="Group_41962" data-name="Group 41962">
                <path
                  id="Path_64660"
                  data-name="Path 64660"
                  d="M1264.268,1131.626s-1.549-2.218-.014-3.983c1.654-1.9,2.776-1.729,3.985-1.43,1.529.379,2.359.889,2.937.751.309-.074.578-.343.632-.167a2.238,2.238,0,0,1-.7,2.021,2.656,2.656,0,0,1-3.139.152c-1.135-.557-1.664-.472-2.118.232-.482.747.231,2.07.231,2.07l-.342.133S1264.418,1130.672,1264.268,1131.626Z"
                  transform="translate(-1263.575 -1126.028)"
                  fill="#050f64"
                />
              </g>
            </g>
            <g
              id="Group_41964"
              data-name="Group 41964"
              transform="translate(4.886 4.314)"
            >
              <path
                id="Path_64661"
                data-name="Path 64661"
                d="M1268.8,1149.433a1.171,1.171,0,1,1-1.131-1.068A1.1,1.1,0,0,1,1268.8,1149.433Z"
                transform="translate(-1266.476 -1148.364)"
                fill="#f5bdc8"
              />
            </g>
          </g>
          <g
            id="Group_41998"
            data-name="Group 41998"
            transform="translate(12409.748 -9638.407)"
          >
            <g
              id="Group_41966"
              data-name="Group 41966"
              transform="translate(44.556 71.664)"
            >
              <path
                id="Path_64662"
                data-name="Path 64662"
                d="M1160.426,1500.5a.829.829,0,0,1,.525-.279,5.092,5.092,0,0,1,.607-.035,3.212,3.212,0,0,0,1.42-.411,4.818,4.818,0,0,1,.682-.372l1.427.037a1.633,1.633,0,0,1,.381.769,2.879,2.879,0,0,1,.045.782v.3h-5.233v-.3h0A.811.811,0,0,1,1160.426,1500.5Z"
                transform="translate(-1160.279 -1499.406)"
                fill="#050f64"
              />
            </g>
            <g
              id="Group_41967"
              data-name="Group 41967"
              transform="translate(47.842 70.117)"
            >
              <path
                id="Path_64663"
                data-name="Path 64663"
                d="M1178.992,1491.4l-.18,1.586-1.427-.039-.095-1.464Z"
                transform="translate(-1177.29 -1491.4)"
                fill="#f5bdc8"
              />
            </g>
            <g
              id="Group_41968"
              data-name="Group 41968"
              transform="translate(30.535 71.468)"
            >
              <path
                id="Path_64664"
                data-name="Path 64664"
                d="M1087.925,1499.122a.829.829,0,0,1,.552-.219,5.016,5.016,0,0,1,.608.033,3.216,3.216,0,0,0,1.457-.249,4.822,4.822,0,0,1,.719-.293l1.413.2a1.632,1.632,0,0,1,.292.807,2.876,2.876,0,0,1-.043.782l-.033.3-5.2-.588.034-.3h0A.8.8,0,0,1,1087.925,1499.122Z"
                transform="translate(-1087.691 -1498.395)"
                fill="#050f64"
              />
            </g>
            <g
              id="Group_41969"
              data-name="Group 41969"
              transform="translate(33.903 29.361)"
            >
              <path
                id="Path_64665"
                data-name="Path 64665"
                d="M1122.02,1298.144c.3-5.52.248-13.341-1.247-17.746-.014-.08-11.569.958-11.569.959l-2.7,11.094a48.733,48.733,0,0,0-1.379,11.927l.14,16.648,1.95.126,3.612-22.048a85.65,85.65,0,0,0,3.9-8.567l4.2,30.7,1.952-.094s1.134-22.984,1.133-23Z"
                transform="translate(-1105.126 -1280.393)"
                fill="#3b4046"
              />
            </g>
            <g
              id="Group_41970"
              data-name="Group 41970"
              transform="translate(34.105 70.001)"
            >
              <path
                id="Path_64666"
                data-name="Path 64666"
                d="M1107.939,1490.91l-.355,1.555-1.414-.2.07-1.468Z"
                transform="translate(-1106.17 -1490.8)"
                fill="#f5bdc8"
              />
            </g>
            <g
              id="Group_41974"
              data-name="Group 41974"
              transform="translate(15 9.033)"
            >
              <g id="Group_41972" data-name="Group 41972">
                <g id="Group_41971" data-name="Group 41971">
                  <path
                    id="Path_64667"
                    data-name="Path 64667"
                    d="M1007.334,1175.571a.714.714,0,0,1,.9-.374,64.113,64.113,0,0,0,6.106,2.032,48.014,48.014,0,0,0,6.211,1.288,40.335,40.335,0,0,0,6.228.363q1.549-.038,3.078-.2c.255-.03.509-.053.763-.088l.76-.1c.5-.082,1.008-.16,1.508-.261a2.189,2.189,0,0,1,.473-.025,2.076,2.076,0,0,1,.457.069,2.533,2.533,0,0,1,.835.41,2.7,2.7,0,0,1,1.032,1.671,2.427,2.427,0,0,1-.444,1.921,2.335,2.335,0,0,1-.758.653,2.592,2.592,0,0,1-.479.2,2.469,2.469,0,0,1-.53.094c-.578.035-1.157.045-1.735.057h-.867c-.288,0-.577-.013-.865-.02q-1.728-.056-3.437-.252a44.036,44.036,0,0,1-6.684-1.323,50.781,50.781,0,0,1-6.324-2.249,66.018,66.018,0,0,1-5.941-2.932A.707.707,0,0,1,1007.334,1175.571Z"
                    transform="translate(-1007.261 -1175.15)"
                    fill="#ea8096"
                  />
                </g>
              </g>
              <g
                id="Group_41973"
                data-name="Group 41973"
                transform="translate(19.345 2.285)"
              >
                <path
                  id="Path_64668"
                  data-name="Path 64668"
                  d="M1107.848,1193.653l5.724-.4a3.085,3.085,0,0,0,2.976-3.235h0a3.29,3.29,0,0,0-3.41-3.035l-5.724.4Z"
                  transform="translate(-1107.414 -1186.979)"
                  fill="#ffbd00"
                />
              </g>
            </g>
            <g
              id="Group_41975"
              data-name="Group 41975"
              transform="translate(37.034 10.713)"
            >
              <path
                id="Path_64669"
                data-name="Path 64669"
                d="M1128.555,1183.848h0a7.141,7.141,0,0,0-7.146,8.129l.876,11.481a12.92,12.92,0,0,0,11.569-.959l.524-12.217A5.908,5.908,0,0,0,1128.555,1183.848Z"
                transform="translate(-1121.338 -1183.848)"
                fill="#ffd800"
              />
            </g>
            <g
              id="Group_41976"
              data-name="Group 41976"
              transform="translate(36.981 10.587)"
            >
              <path
                id="Path_64670"
                data-name="Path 64670"
                d="M1133.184,1185.733l-.087.1a5.879,5.879,0,0,1,.975,2.291l.124-.011A6.025,6.025,0,0,0,1133.184,1185.733Zm-4.829,18.056v.128a12.454,12.454,0,0,0,3.182-.8l-.04-.12A12.513,12.513,0,0,1,1128.355,1203.789Zm2.5-20.005a6.043,6.043,0,0,0-2.526-.585h-.077a7.268,7.268,0,0,0-7.09,5.675l.122.025a7.145,7.145,0,0,1,7.044-5.574,5.885,5.885,0,0,1,2.5.584Zm-8.908,17.7-.122.065.113,1.477.077.028a15.826,15.826,0,0,0,3.2.812v-.126a15.672,15.672,0,0,1-3.158-.8Zm-.888-9.99.442,5.788h.127l-.442-5.788Z"
                transform="translate(-1121.06 -1183.199)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_41977"
              data-name="Group 41977"
              transform="translate(43.113 2.742)"
            >
              <path
                id="Path_64671"
                data-name="Path 64671"
                d="M1155.017,1142.58a3.182,3.182,0,0,1,2.266,4.057c-.5,2.24-2.125,3.375-4.474,3.759Z"
                transform="translate(-1152.809 -1142.58)"
                fill="#050f64"
              />
            </g>
            <g
              id="Group_41983"
              data-name="Group 41983"
              transform="translate(40.566 1.545)"
            >
              <g
                id="Group_41978"
                data-name="Group 41978"
                transform="translate(1.604 6.688)"
              >
                <path
                  id="Path_64672"
                  data-name="Path 64672"
                  d="M1147.93,1171.162l.231,3.46a2.429,2.429,0,0,0,2.85-.15l-.231-3.461Z"
                  transform="translate(-1147.93 -1171.012)"
                  fill="#f5bdc8"
                />
              </g>
              <g
                id="Group_41979"
                data-name="Group 41979"
                transform="translate(1.626 7.084)"
              >
                <path
                  id="Path_64673"
                  data-name="Path 64673"
                  d="M1148.04,1173.213l.057,1.085a3.113,3.113,0,0,0,1.471.36l.089,0a1.9,1.9,0,0,0,1.286-.592l-.053-1Z"
                  transform="translate(-1148.04 -1173.063)"
                  fill="#ea8096"
                />
              </g>
              <g
                id="Group_41980"
                data-name="Group 41980"
                transform="translate(0.206 1.679)"
              >
                <path
                  id="Path_64674"
                  data-name="Path 64674"
                  d="M1140.69,1146.182l.2,2.545.044.564a2.714,2.714,0,0,0,2.718,2.482,1.525,1.525,0,0,0,.424-.062c.053-.016.106-.034.159-.056l.033-.014a1.484,1.484,0,0,0,.528-.388,4.576,4.576,0,0,0,.7-1.189,7.807,7.807,0,0,0,.4-1.084,3.51,3.51,0,0,0,.12-1.341l-.192-2.232-4.349-.329Z"
                  transform="translate(-1140.69 -1145.079)"
                  fill="#f5bdc8"
                />
              </g>
              <g id="Group_41981" data-name="Group 41981">
                <path
                  id="Path_64675"
                  data-name="Path 64675"
                  d="M1144.307,1138.514s-4.976.309-4,4.676c0,0-1.566-3.164.028-5.284,1.755-2.334,4.1-1.567,4.928-.453s1.455,2.966-.862,4.289A3.814,3.814,0,0,0,1144.307,1138.514Z"
                  transform="translate(-1139.624 -1136.385)"
                  fill="#050f64"
                />
              </g>
              <g
                id="Group_41982"
                data-name="Group 41982"
                transform="translate(4.577 3.702)"
              >
                <path
                  id="Path_64676"
                  data-name="Path 64676"
                  d="M1163.324,1156.644a1.038,1.038,0,1,0,.982-1.092A1.038,1.038,0,0,0,1163.324,1156.644Z"
                  transform="translate(-1163.322 -1155.55)"
                  fill="#f5bdc8"
                />
              </g>
            </g>
            <g
              id="Group_41992"
              data-name="Group 41992"
              transform="translate(0 0)"
            >
              <g
                id="Group_41984"
                data-name="Group 41984"
                transform="translate(0)"
              >
                <rect
                  id="Rectangle_20117"
                  data-name="Rectangle 20117"
                  width="28.53"
                  height="45.425"
                  transform="translate(0 19.988) rotate(-44.473)"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41985"
                data-name="Group 41985"
                transform="translate(0.601 0.601)"
              >
                <rect
                  id="Rectangle_20118"
                  data-name="Rectangle 20118"
                  width="27.68"
                  height="44.575"
                  transform="translate(0 19.393) rotate(-44.473)"
                  fill="#fff"
                />
              </g>
              <g
                id="Group_41986"
                data-name="Group 41986"
                transform="translate(3.161 16.894)"
              >
                <rect
                  id="Rectangle_20119"
                  data-name="Rectangle 20119"
                  width="4.458"
                  height="40.953"
                  transform="translate(0 3.123) rotate(-44.473)"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41987"
                data-name="Group 41987"
                transform="translate(15.734 19.404)"
              >
                <rect
                  id="Rectangle_20120"
                  data-name="Rectangle 20120"
                  width="8.048"
                  height="28.56"
                  transform="translate(0 5.639) rotate(-44.473)"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41988"
                data-name="Group 41988"
                transform="translate(13.503 5.964)"
              >
                <rect
                  id="Rectangle_20121"
                  data-name="Rectangle 20121"
                  width="5.564"
                  height="40.953"
                  transform="translate(0 3.898) rotate(-44.473)"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41989"
                data-name="Group 41989"
                transform="translate(18.182 3.162)"
              >
                <rect
                  id="Rectangle_20122"
                  data-name="Rectangle 20122"
                  width="3.008"
                  height="40.953"
                  transform="translate(0 2.107) rotate(-44.473)"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41990"
                data-name="Group 41990"
                transform="translate(10.277 10.56)"
              >
                <rect
                  id="Rectangle_20123"
                  data-name="Rectangle 20123"
                  width="3.527"
                  height="11.4"
                  transform="translate(0 2.471) rotate(-44.473)"
                  fill="#e5e6eb"
                />
              </g>
              <g
                id="Group_41991"
                data-name="Group 41991"
                transform="translate(7.051 13.727)"
              >
                <rect
                  id="Rectangle_20124"
                  data-name="Rectangle 20124"
                  width="3.527"
                  height="11.4"
                  transform="translate(0 2.471) rotate(-44.473)"
                  fill="#e5e6eb"
                />
              </g>
            </g>
            <g
              id="Group_41997"
              data-name="Group 41997"
              transform="translate(38.98 12.895)"
            >
              <g
                id="Group_41994"
                data-name="Group 41994"
                transform="translate(0 0.208)"
              >
                <g id="Group_41993" data-name="Group 41993">
                  <path
                    id="Path_64677"
                    data-name="Path 64677"
                    d="M1131.809,1224.428a.714.714,0,0,1-.345-.908,64.149,64.149,0,0,0,2.23-6.036,48,48,0,0,0,1.491-6.166,40.347,40.347,0,0,0,.566-6.213q.013-1.549-.1-3.083c-.022-.255-.036-.51-.063-.765l-.079-.763c-.065-.507-.127-1.013-.211-1.516a2.2,2.2,0,0,1-.01-.474,2.093,2.093,0,0,1,.084-.455,2.528,2.528,0,0,1,.437-.821,2.7,2.7,0,0,1,1.7-.977,2.428,2.428,0,0,1,1.906.507,2.336,2.336,0,0,1,.628.779,2.559,2.559,0,0,1,.187.485,2.481,2.481,0,0,1,.077.532c.016.579.007,1.158,0,1.736l-.03.866c-.01.288-.032.577-.048.864q-.113,1.725-.364,3.427a44.035,44.035,0,0,1-1.541,6.637,50.808,50.808,0,0,1-2.455,6.247,66.032,66.032,0,0,1-3.125,5.841A.707.707,0,0,1,1131.809,1224.428Z"
                    transform="translate(-1131.409 -1196.222)"
                    fill="#f5bdc8"
                  />
                </g>
              </g>
              <g
                id="Group_41995"
                data-name="Group 41995"
                transform="translate(3.185 0.127)"
              >
                <path
                  id="Path_64678"
                  data-name="Path 64678"
                  d="M1154.392,1204.622l-.209-5.734a3.085,3.085,0,0,0-3.136-3.08h0a3.29,3.29,0,0,0-3.145,3.309l.209,5.734Z"
                  transform="translate(-1147.9 -1195.805)"
                  fill="#ffbd00"
                />
              </g>
              <g
                id="Group_41996"
                data-name="Group 41996"
                transform="translate(3.089)"
              >
                <path
                  id="Path_64679"
                  data-name="Path 64679"
                  d="M1151.675,1195.287a3.079,3.079,0,0,0-1.036-.138,3.444,3.444,0,0,0-2.333,1.066,3.6,3.6,0,0,0-.281.331l.111.064a3.324,3.324,0,0,1,2.508-1.335,2.988,2.988,0,0,1,2.867,1.867l.1-.073A3.178,3.178,0,0,0,1151.675,1195.287Zm2.231,3.065c0-.02,0-.039,0-.058l-.122.1.063,1.724.126-.018Zm.087,2.385-.125.056.059,1.615.126-.028Zm.089,2.465-.126.027.032.861-4.818.176-.006.127,4.956-.18Zm-6.681-3.834.152,4.176.127.007-.153-4.209Z"
                  transform="translate(-1147.4 -1195.147)"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
          <g
            id="Group_42028"
            data-name="Group 42028"
            transform="translate(12361.236 -9638.753)"
          >
            <g
              id="Group_42002"
              data-name="Group 42002"
              transform="translate(7.062 11.209)"
            >
              <g
                id="Group_41999"
                data-name="Group 41999"
                transform="translate(0.192 0.834)"
              >
                <path
                  id="Path_64680"
                  data-name="Path 64680"
                  d="M747.241,1189.4a.755.755,0,0,0-1.02-.137c-.421.283-.856.557-1.277.823l-.308.195c-.17.107-.343.21-.515.314l-.287.173-.4.241-.406.232c-.1.054-.193.11-.29.165-.17.1-.346.2-.522.292l-.818.437-.828.409c-.175.087-.356.168-.531.246-.1.045-.2.09-.3.136a19.941,19.941,0,0,1-3.385,1.168,13.478,13.478,0,0,1-3.41.389,17.2,17.2,0,0,1-6.667-1.694c-.983-.434-2.048-.963-3.255-1.616-.964-.527-1.989-1.114-3.226-1.847a2.75,2.75,0,0,0-2.108-.28,2.3,2.3,0,0,0-1.419,1.115,2.257,2.257,0,0,0-.144,1.794,2.766,2.766,0,0,0,1.457,1.615c1.367.619,2.5,1.112,3.577,1.553,1.4.569,2.59,1,3.738,1.365a26.386,26.386,0,0,0,3.982.953q.186.028.371.053a17.311,17.311,0,0,0,3.823.1,16.325,16.325,0,0,0,4.06-.92,22.519,22.519,0,0,0,3.639-1.72c.1-.059.2-.117.3-.175.182-.107.371-.217.551-.333l.827-.529.8-.551c.175-.118.348-.245.515-.366.092-.067.183-.134.276-.2l.393-.285.384-.293.27-.206c.166-.127.332-.253.5-.383l.279-.223c.4-.32.817-.652,1.216-.988A.746.746,0,0,0,747.241,1189.4Z"
                  transform="translate(-716.002 -1188.949)"
                  fill="#ea8096"
                />
              </g>
              <g id="Group_42001" data-name="Group 42001">
                <g id="Group_42000" data-name="Group 42000">
                  <path
                    id="Path_64681"
                    data-name="Path 64681"
                    d="M722.8,1194.089l-5.741-2.814a3.437,3.437,0,0,1-1.712-4.589l.109-.1a3.5,3.5,0,0,1,4.686-1.6l5.741,2.814Z"
                    transform="translate(-715.008 -1184.628)"
                    fill="#ffbd00"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_42003"
              data-name="Group 42003"
              transform="translate(15.632 71.771)"
            >
              <path
                id="Path_64682"
                data-name="Path 64682"
                d="M759.385,1500.3h7.007a1.077,1.077,0,0,0-.2-.657,1.11,1.11,0,0,0-.7-.374,6.689,6.689,0,0,0-.813-.047,4.306,4.306,0,0,1-1.9-.551,6.4,6.4,0,0,0-.913-.5l-1.91.05a2.192,2.192,0,0,0-.51,1.03A3.857,3.857,0,0,0,759.385,1500.3Z"
                transform="translate(-759.374 -1498.172)"
                fill="#050f64"
              />
            </g>
            <g
              id="Group_42004"
              data-name="Group 42004"
              transform="translate(1.988 71.771)"
            >
              <path
                id="Path_64683"
                data-name="Path 64683"
                d="M688.75,1500.3h7.007a1.078,1.078,0,0,0-.2-.657,1.11,1.11,0,0,0-.7-.374,6.688,6.688,0,0,0-.813-.047,4.306,4.306,0,0,1-1.9-.551,6.408,6.408,0,0,0-.913-.5l-1.91.05a2.191,2.191,0,0,0-.51,1.03A3.852,3.852,0,0,0,688.75,1500.3Z"
                transform="translate(-688.739 -1498.172)"
                fill="#050f64"
              />
            </g>
            <g
              id="Group_42005"
              data-name="Group 42005"
              transform="translate(0.762 34.139)"
            >
              <path
                id="Path_64684"
                data-name="Path 64684"
                d="M700.121,1340.991l-.761-21.593s-.026-.387-.036-.446l-1.867-14.986c-.128-1.88-15.07,1.1-15.07,1.1l1.674,35.985,2.471-.079,3.485-29.385,4.186,8.289,3.388,21.175Z"
                transform="translate(-682.388 -1303.344)"
                fill="#3b4046"
              />
            </g>
            <g
              id="Group_42006"
              data-name="Group 42006"
              transform="translate(0.136 10.295)"
            >
              <path
                id="Path_64685"
                data-name="Path 64685"
                d="M685.984,1179.973h0a6.56,6.56,0,0,1,7.533,6.049l1.328,18.341c-5.914,3.338-9.586,2.534-15.07,1.1l-.62-17.25A8.045,8.045,0,0,1,685.984,1179.973Z"
                transform="translate(-679.15 -1179.897)"
                fill="#ffd800"
              />
            </g>
            <g
              id="Group_42007"
              data-name="Group 42007"
              transform="translate(0 10.091)"
            >
              <path
                id="Path_64686"
                data-name="Path 64686"
                d="M678.649,1189.1h-.2l.3,8.378h.205Zm15.406,8.537-.2.015.425,5.863c-5.6,3.162-9.194,2.606-14.221,1.321l.007.212a25.179,25.179,0,0,0,6.3,1.012,15.772,15.772,0,0,0,8.018-2.368l.113-.063Zm-7.642-18.589a6.562,6.562,0,0,1,6.535,6.124l.406,5.615h.2l-.407-5.629a6.76,6.76,0,0,0-7.767-6.237l-.072.011-.015.21.118-.019A6.7,6.7,0,0,1,686.413,1179.047Z"
                transform="translate(-678.445 -1178.843)"
                fill="#fff"
              />
            </g>
            <g
              id="Group_42014"
              data-name="Group 42014"
              transform="translate(3.712 0)"
            >
              <g
                id="Group_42011"
                data-name="Group 42011"
                transform="translate(2.052 2.768)"
              >
                <g
                  id="Group_42008"
                  data-name="Group 42008"
                  transform="translate(0.136 5.305)"
                >
                  <path
                    id="Path_64687"
                    data-name="Path 64687"
                    d="M712.591,1168.779,712,1173.41a2.588,2.588,0,0,1-3.017-.383l.588-4.631Z"
                    transform="translate(-708.985 -1168.396)"
                    fill="#f5bdc8"
                  />
                </g>
                <g
                  id="Group_42009"
                  data-name="Group 42009"
                  transform="translate(0.566 5.305)"
                >
                  <path
                    id="Path_64688"
                    data-name="Path 64688"
                    d="M714.388,1168.778l-.266,2.094a2.456,2.456,0,0,1-.7.069q-.115-.005-.229-.02a2.736,2.736,0,0,1-1.985-1.285l.158-1.243Z"
                    transform="translate(-711.213 -1168.395)"
                    fill="#ea8096"
                  />
                </g>
                <g id="Group_42010" data-name="Group 42010">
                  <path
                    id="Path_64689"
                    data-name="Path 64689"
                    d="M713.755,1143.961l-.32,1.926-.129.779a2.167,2.167,0,0,1-2.23,1.812,2.426,2.426,0,0,1-1.017-.271,2.381,2.381,0,0,1-.208-.122c-.042-.027-.083-.055-.123-.085a2.378,2.378,0,0,1-.839-1.154c-.134-.4-.252-.832-.359-1.289-.062-.261-.121-.529-.177-.8a3.3,3.3,0,0,1,1.117-3.231,2.657,2.657,0,0,1,4.284,2.437Z"
                    transform="translate(-708.283 -1140.931)"
                    fill="#f5bdc8"
                  />
                </g>
              </g>
              <g id="Group_42012" data-name="Group 42012">
                <path
                  id="Path_64690"
                  data-name="Path 64690"
                  d="M705.791,1132.984a1.061,1.061,0,0,0,.268-.844,1.972,1.972,0,0,1,.1-.91c.173-.351.577-.518.68-.9a1.063,1.063,0,0,0-.374-.955l-1.816-1.976a2.878,2.878,0,0,0-.817-.695.934.934,0,0,0-1.008.091c-.157.129-.279.318-.441.438a1.329,1.329,0,0,1-1.206.01,2.068,2.068,0,0,0-1.509.035,1.5,1.5,0,0,0-.8,1.464,3.093,3.093,0,0,0,.3.759,1.122,1.122,0,0,1,.08.825c-.137.367-.508.5-.8.712a2.016,2.016,0,0,0-.766,1.372,1.81,1.81,0,0,0,.441,1.448.709.709,0,0,0,1.074.034c.325-.413.211-1.2.633-1.452.506-.3,1.007.664,1.508.354.269-.166.341-.6.578-.83.313-.3.725-.129,1.038-.01a5.635,5.635,0,0,0,1.018.266,1.717,1.717,0,0,1,.829.43C705.061,1132.878,705.422,1133.255,705.791,1132.984Z"
                  transform="translate(-697.661 -1126.598)"
                  fill="#050f64"
                />
              </g>
              <g
                id="Group_42013"
                data-name="Group 42013"
                transform="translate(1.347 5.572)"
              >
                <path
                  id="Path_64691"
                  data-name="Path 64691"
                  d="M706.9,1156.6a1.147,1.147,0,1,1-1-1.15A1.082,1.082,0,0,1,706.9,1156.6Z"
                  transform="translate(-704.634 -1155.444)"
                  fill="#f5bdc8"
                />
              </g>
            </g>
            <g
              id="Group_42027"
              data-name="Group 42027"
              transform="translate(1.3 13.462)"
            >
              <g id="Group_42018" data-name="Group 42018">
                <g
                  id="Group_42015"
                  data-name="Group 42015"
                  transform="translate(0.704 0.523)"
                >
                  <path
                    id="Path_64692"
                    data-name="Path 64692"
                    d="M715.884,1215.6c-.517,0-1.042-.018-1.549-.034l-.371-.011c-.206-.007-.412-.018-.617-.029l-.338-.017-.476-.025-.475-.036-.337-.026c-.2-.015-.408-.029-.61-.052l-.941-.1-.933-.127c-.2-.026-.4-.062-.591-.1-.11-.02-.221-.039-.33-.057a20.317,20.317,0,0,1-3.527-.945,13.734,13.734,0,0,1-3.1-1.618,17.542,17.542,0,0,1-4.666-5.238c-.583-.928-1.181-1.983-1.828-3.224-.513-.994-1.044-2.075-1.672-3.4a2.8,2.8,0,0,0-1.622-1.44,2.348,2.348,0,0,0-1.836.132,2.3,2.3,0,0,0-1.146,1.434,2.82,2.82,0,0,0,.309,2.2c.806,1.309,1.484,2.374,2.135,3.354.86,1.281,1.616,2.325,2.379,3.288a26.9,26.9,0,0,0,2.821,3.078,17.846,17.846,0,0,0,3.458,2.522,16.656,16.656,0,0,0,3.956,1.54,22.938,22.938,0,0,0,4.057.624l.348.021c.216.014.438.028.657.033l1,.025.994-.006h.015c.211,0,.423-.008.629-.016l.348-.012.495-.017.492-.028.346-.02c.213-.012.426-.024.638-.04l.362-.029c.523-.042,1.063-.084,1.592-.141a.761.761,0,0,0,.72-.765A.771.771,0,0,0,715.884,1215.6Z"
                    transform="translate(-688.815 -1198.997)"
                    fill="#f4bcc7"
                  />
                </g>
                <g
                  id="Group_42016"
                  data-name="Group 42016"
                  transform="translate(0.206 0.206)"
                >
                  <path
                    id="Path_64693"
                    data-name="Path 64693"
                    d="M690.119,1208.359l-3.336-5.6a3.505,3.505,0,0,1,1.095-4.873l.146-.022a3.571,3.571,0,0,1,4.9,1.241l3.336,5.6Z"
                    transform="translate(-686.238 -1197.358)"
                    fill="#ffbd00"
                  />
                </g>
                <g id="Group_42017" data-name="Group 42017">
                  <path
                    id="Path_64694"
                    data-name="Path 64694"
                    d="M692.236,1198.136a3.8,3.8,0,0,0-3.247-1.844,3.746,3.746,0,0,0-.95.122l.087.19a3.571,3.571,0,0,1,3.934,1.637l.875,1.47.182-.1Zm2.643,4.439-.182.1.7,1.172-3.728,2.22.1.179,3.91-2.328Zm-8.2-5.325-.1-.181a3.507,3.507,0,0,0-1.326,2.091,3.935,3.935,0,0,0,.49,2.841l2.626,4.409.2-.071-2.646-4.443A3.529,3.529,0,0,1,686.684,1197.25Z"
                    transform="translate(-685.173 -1196.292)"
                    fill="#fff"
                  />
                </g>
              </g>
              <g
                id="Group_42025"
                data-name="Group 42025"
                transform="translate(10.255 6.283)"
              >
                <g
                  id="Group_42020"
                  data-name="Group 42020"
                  transform="translate(0 7.938)"
                >
                  <g
                    id="Group_42019"
                    data-name="Group 42019"
                    transform="translate(0 0)"
                  >
                    <rect
                      id="Rectangle_20125"
                      data-name="Rectangle 20125"
                      width="0.65"
                      height="19.365"
                      transform="translate(0 0.642) rotate(-80.741)"
                      fill="#dca000"
                    />
                  </g>
                </g>
                <g
                  id="Group_42022"
                  data-name="Group 42022"
                  transform="translate(7.337)"
                >
                  <g id="Group_42021" data-name="Group 42021">
                    <path
                      id="Path_64695"
                      data-name="Path 64695"
                      d="M788.126,1239.874l-11.871-1.935,5.251-9.119,11.871,1.935Z"
                      transform="translate(-776.255 -1228.82)"
                      fill="#ffbd00"
                    />
                  </g>
                </g>
                <g
                  id="Group_42024"
                  data-name="Group 42024"
                  transform="translate(14.814 4.457)"
                >
                  <g id="Group_42023" data-name="Group 42023">
                    <path
                      id="Path_64696"
                      data-name="Path 64696"
                      d="M816.576,1253.922c-.4.957-1.019,1.612-1.373,1.462s-.314-1.047.089-2,1.018-1.612,1.373-1.462S816.98,1252.965,816.576,1253.922Z"
                      transform="translate(-814.962 -1251.897)"
                      fill="#fff"
                    />
                  </g>
                </g>
              </g>
              <g
                id="Group_42026"
                data-name="Group 42026"
                transform="translate(7.779 11.095)"
              >
                <path
                  id="Path_64697"
                  data-name="Path 64697"
                  d="M725.447,1256.127c.222.224.446.438.669.644a17.827,17.827,0,0,0,3.458,2.522,16.631,16.631,0,0,0,3.956,1.54,22.737,22.737,0,0,0,3.96.617l.758-2.229-.048-.008-.331-.056a20.407,20.407,0,0,1-3.527-.946,13.71,13.71,0,0,1-3.1-1.618,14.758,14.758,0,0,1-2.986-2.858c-.138.194-.281.382-.427.571a6.746,6.746,0,0,1-.667.778,3.514,3.514,0,0,1-.668.6l-.463.264A2.4,2.4,0,0,1,725.447,1256.127Z"
                  transform="translate(-725.447 -1253.735)"
                  fill="#f4bcc7"
                />
              </g>
            </g>
          </g>
          <g
            id="Group_42029"
            data-name="Group 42029"
            transform="translate(12289.758 -9554.034)"
          >
            <path
              id="Path_64698"
              data-name="Path 64698"
              d="M573.145,1570.039H310.8a2.414,2.414,0,0,1-2.414-2.414h0a2.414,2.414,0,0,1,2.414-2.414H573.146a2.414,2.414,0,0,1,2.414,2.414h0A2.416,2.416,0,0,1,573.145,1570.039Z"
              transform="translate(-308.385 -1565.21)"
              fill="#e5e6eb"
            />
          </g>
          <g
            id="Group_42035"
            data-name="Group 42035"
            transform="translate(12363.999 -9754.922)"
          >
            <g
              id="Group_42030"
              data-name="Group 42030"
              transform="translate(0 2.186)"
            >
              <rect
                id="Rectangle_20126"
                data-name="Rectangle 20126"
                width="22.403"
                height="22.403"
                fill="#e5e6eb"
              />
            </g>
            <g
              id="Group_42031"
              data-name="Group 42031"
              transform="translate(2.186 0)"
            >
              <rect
                id="Rectangle_20127"
                data-name="Rectangle 20127"
                width="22.403"
                height="22.403"
                fill="#fff"
              />
            </g>
            <g
              id="Group_42032"
              data-name="Group 42032"
              transform="translate(4.754 2.659)"
            >
              <rect
                id="Rectangle_20128"
                data-name="Rectangle 20128"
                width="17.267"
                height="13.661"
                fill="#3b4046"
              />
            </g>
            <g
              id="Group_42033"
              data-name="Group 42033"
              transform="translate(4.754 7.145)"
            >
              <path
                id="Path_64699"
                data-name="Path 64699"
                d="M717.359,571.331l6-5.957a1.093,1.093,0,0,1,1.636.11l1.867,2.431,4.492-5.368a1.093,1.093,0,0,1,1.768.127l1.5,2.427v6.229H717.359Z"
                transform="translate(-717.359 -562.156)"
                fill="#ffd800"
              />
            </g>
            <g
              id="Group_42034"
              data-name="Group 42034"
              transform="translate(7.012 4.007)"
            >
              <circle
                id="Ellipse_1322"
                data-name="Ellipse 1322"
                cx="2.477"
                cy="2.477"
                r="2.477"
                fill="#fff"
              />
            </g>
          </g>
        </g>
        <g
          id="Group_42039"
          data-name="Group 42039"
          transform="translate(1724.883 1159.27)"
        >
          <g
            id="Group_4218"
            data-name="Group 4218"
            transform="translate(0 15.076)"
          >
            <rect
              id="Rectangle_2687"
              data-name="Rectangle 2687"
              width="129.304"
              height="58.04"
              rx="19.669"
              transform="translate(6.813 18.071)"
              fill="#e0e0e0"
            />
            <rect
              id="Rectangle_2688"
              data-name="Rectangle 2688"
              width="129.304"
              height="58.04"
              rx="19.669"
              transform="translate(0 18.499)"
              fill="#f5f5f5"
            />
            <path
              id="Rectangle_2689"
              data-name="Rectangle 2689"
              d="M13.738,0h89.214A13.738,13.738,0,0,1,116.69,13.738v7.915a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V13.738A13.738,13.738,0,0,1,13.738,0Z"
              transform="translate(6.687 23.972)"
              fill="#e0e0e0"
            />
            <path
              id="Rectangle_2690"
              data-name="Rectangle 2690"
              d="M0,0H116.69a0,0,0,0,1,0,0V7.915a13.738,13.738,0,0,1-13.738,13.738H13.738A13.738,13.738,0,0,1,0,7.915V0A0,0,0,0,1,0,0Z"
              transform="translate(6.687 48.556)"
              fill="#e0e0e0"
            />
            <g
              id="Group_4192"
              data-name="Group 4192"
              transform="translate(65.154 25.449)"
            >
              <rect
                id="Rectangle_2691"
                data-name="Rectangle 2691"
                width="21.365"
                height="17.605"
                transform="translate(5.472 2.715)"
                fill="#e6e6e6"
              />
              <rect
                id="Rectangle_2692"
                data-name="Rectangle 2692"
                width="5.472"
                height="17.605"
                transform="translate(0 2.715)"
                fill="#f5f5f5"
              />
              <path
                id="Path_15999"
                data-name="Path 15999"
                d="M362.495,333.226a1.8,1.8,0,1,1-1.8-1.8A1.8,1.8,0,0,1,362.495,333.226Z"
                transform="translate(-357.959 -317.643)"
                fill="#e0e0e0"
              />
              <rect
                id="Rectangle_2693"
                data-name="Rectangle 2693"
                width="16.049"
                height="20.32"
                transform="translate(16.39)"
                fill="#e6e6e6"
              />
              <g
                id="Group_4191"
                data-name="Group 4191"
                transform="translate(11.757)"
              >
                <rect
                  id="Rectangle_2694"
                  data-name="Rectangle 2694"
                  width="4.64"
                  height="20.32"
                  fill="#f5f5f5"
                />
                <circle
                  id="Ellipse_48"
                  data-name="Ellipse 48"
                  cx="1.59"
                  cy="1.59"
                  r="1.59"
                  transform="translate(0.73 1.362)"
                  fill="#e0e0e0"
                />
              </g>
              <circle
                id="Ellipse_49"
                data-name="Ellipse 49"
                cx="1.59"
                cy="1.59"
                r="1.59"
                transform="translate(12.487 1.362)"
                fill="#e0e0e0"
              />
              <rect
                id="Rectangle_2695"
                data-name="Rectangle 2695"
                width="13.531"
                height="17.605"
                transform="translate(21.119 2.715)"
                fill="#ebebeb"
              />
              <rect
                id="Rectangle_2696"
                data-name="Rectangle 2696"
                width="3.091"
                height="17.605"
                transform="translate(18.028 2.715)"
                fill="#f5f5f5"
              />
              <rect
                id="Rectangle_2697"
                data-name="Rectangle 2697"
                width="17.748"
                height="14.626"
                transform="translate(32.194 5.694)"
                fill="#e6e6e6"
              />
              <rect
                id="Rectangle_2698"
                data-name="Rectangle 2698"
                width="4.545"
                height="14.626"
                transform="translate(27.649 5.694)"
                fill="#f5f5f5"
              />
              <rect
                id="Rectangle_2699"
                data-name="Rectangle 2699"
                width="13.333"
                height="16.881"
                transform="translate(41.262 3.439)"
                fill="#e6e6e6"
              />
              <rect
                id="Rectangle_2700"
                data-name="Rectangle 2700"
                width="3.855"
                height="16.881"
                transform="translate(37.414 3.439)"
                fill="#f5f5f5"
              />
              <rect
                id="Rectangle_2701"
                data-name="Rectangle 2701"
                width="12.951"
                height="14.626"
                transform="translate(45.193 5.694)"
                fill="#e6e6e6"
              />
              <rect
                id="Rectangle_2702"
                data-name="Rectangle 2702"
                width="2.566"
                height="14.626"
                transform="translate(42.62 5.694)"
                fill="#f0f0f0"
              />
            </g>
            <g
              id="Group_4193"
              data-name="Group 4193"
              transform="translate(20.146 49.223)"
            >
              <rect
                id="Rectangle_2703"
                data-name="Rectangle 2703"
                width="16.538"
                height="17.605"
                transform="translate(4.236 2.715)"
                fill="#e6e6e6"
              />
              <rect
                id="Rectangle_2704"
                data-name="Rectangle 2704"
                width="4.236"
                height="17.605"
                transform="translate(0 2.715)"
                fill="#f5f5f5"
              />
              <rect
                id="Rectangle_2705"
                data-name="Rectangle 2705"
                width="12.423"
                height="20.32"
                transform="translate(12.687)"
                fill="#e6e6e6"
              />
              <rect
                id="Rectangle_2706"
                data-name="Rectangle 2706"
                width="3.592"
                height="20.32"
                transform="translate(9.101)"
                fill="#f5f5f5"
              />
              <rect
                id="Rectangle_2707"
                data-name="Rectangle 2707"
                width="16.538"
                height="17.605"
                transform="translate(60.656 2.715)"
                fill="#e6e6e6"
              />
              <rect
                id="Rectangle_2708"
                data-name="Rectangle 2708"
                width="4.236"
                height="17.605"
                transform="translate(56.42 2.715)"
                fill="#f5f5f5"
              />
              <rect
                id="Rectangle_2709"
                data-name="Rectangle 2709"
                width="12.423"
                height="20.32"
                transform="translate(69.108)"
                fill="#e6e6e6"
              />
              <rect
                id="Rectangle_2710"
                data-name="Rectangle 2710"
                width="3.592"
                height="20.32"
                transform="translate(65.521)"
                fill="#f5f5f5"
              />
              <rect
                id="Rectangle_2711"
                data-name="Rectangle 2711"
                width="10.474"
                height="17.605"
                transform="translate(16.348 2.715)"
                fill="#ebebeb"
              />
              <rect
                id="Rectangle_2712"
                data-name="Rectangle 2712"
                width="2.393"
                height="17.605"
                transform="translate(13.955 2.715)"
                fill="#f5f5f5"
              />
              <rect
                id="Rectangle_2713"
                data-name="Rectangle 2713"
                width="13.739"
                height="14.626"
                transform="translate(24.921 5.694)"
                fill="#e6e6e6"
              />
              <rect
                id="Rectangle_2714"
                data-name="Rectangle 2714"
                width="3.518"
                height="14.626"
                transform="translate(21.403 5.694)"
                fill="#f5f5f5"
              />
              <rect
                id="Rectangle_2715"
                data-name="Rectangle 2715"
                width="10.321"
                height="16.881"
                transform="translate(31.94 3.439)"
                fill="#e6e6e6"
              />
              <rect
                id="Rectangle_2716"
                data-name="Rectangle 2716"
                width="2.984"
                height="16.881"
                transform="translate(28.961 3.439)"
                fill="#f5f5f5"
              />
              <rect
                id="Rectangle_2717"
                data-name="Rectangle 2717"
                width="10.025"
                height="14.626"
                transform="translate(34.983 5.694)"
                fill="#e6e6e6"
              />
              <rect
                id="Rectangle_2718"
                data-name="Rectangle 2718"
                width="1.986"
                height="14.626"
                transform="translate(32.992 5.694)"
                fill="#f0f0f0"
              />
            </g>
            <g
              id="Group_4205"
              data-name="Group 4205"
              transform="translate(45.002 0)"
            >
              <g id="Group_4203" data-name="Group 4203">
                <g id="Group_4195" data-name="Group 4195">
                  <g id="Group_4194" data-name="Group 4194">
                    <path
                      id="Path_16000"
                      data-name="Path 16000"
                      d="M337.13,277.189a1.773,1.773,0,0,0-1.887-.943,1.872,1.872,0,0,0-1.4,1.631,1.574,1.574,0,0,0-1.791-.047,1.785,1.785,0,0,0-.72,1.733,1.318,1.318,0,0,0-1.914.389,1.48,1.48,0,0,0,.585,1.965.949.949,0,0,0,.047,1.889,1.025,1.025,0,0,0-.941.9,1.06,1.06,0,0,0,.709,1.113.863.863,0,0,0-.205,1.331.775.775,0,0,0,1.222-.388.253.253,0,0,0,.4.064.285.285,0,0,0-.077-.422.469.469,0,0,0,.809-.207,1.166,1.166,0,0,0,1.578,1.244.714.714,0,0,0,.467.96,1.623,1.623,0,0,0,1.14-.222,2.549,2.549,0,0,1,1.119-.377,3.545,3.545,0,0,1,1,.278,3.01,3.01,0,0,0,3.05-.8,1.3,1.3,0,0,0,2.173-.331.972.972,0,0,0,.855.773.957.957,0,0,0,.931-.668c.008.186.017.372.025.558a1.155,1.155,0,0,0,1.183-1.547,1.175,1.175,0,0,0,1.124-1.026,1.219,1.219,0,0,0-.838-1.3,2.289,2.289,0,0,0,.043-4.341,1.089,1.089,0,0,0-1.04.143.659.659,0,0,0,0,.987,2.1,2.1,0,0,0-.9-2.36,1.87,1.87,0,0,0-2.359.505,1.182,1.182,0,0,0,.012-1.305,1.036,1.036,0,0,0-1.177-.4,1.181,1.181,0,0,0-1.275-.967,1.229,1.229,0,0,0-.959,1.313.6.6,0,0,0-1.082-.2C336.715,277.025,337.13,277.189,337.13,277.189Z"
                      transform="translate(-329.098 -275.994)"
                      fill="#ebebeb"
                    />
                  </g>
                </g>
                <g
                  id="Group_4202"
                  data-name="Group 4202"
                  transform="translate(1.684 1.302)"
                >
                  <g
                    id="Group_4196"
                    data-name="Group 4196"
                    transform="translate(5.151 4.921)"
                  >
                    <path
                      id="Path_16001"
                      data-name="Path 16001"
                      d="M340.165,285.409a1.075,1.075,0,0,0-.809-.195.748.748,0,0,0-.59.551.578.578,0,0,0,.393.666c.337.081.674-.2,1.018-.148a3.048,3.048,0,0,1,.355.108,1.734,1.734,0,0,0,1.392-.5,1.472,1.472,0,0,0,.388-.369.5.5,0,0,0,.041-.511.665.665,0,0,0-.673-.219,2.684,2.684,0,0,0-1.372.573l.038-.235Z"
                      transform="translate(-338.755 -284.786)"
                      fill="#fafafa"
                    />
                  </g>
                  <g
                    id="Group_4197"
                    data-name="Group 4197"
                    transform="translate(12.787 4.879)"
                  >
                    <path
                      id="Path_16002"
                      data-name="Path 16002"
                      d="M350.49,284.967a1.3,1.3,0,0,0-.431-.226.44.44,0,0,0-.447.125.448.448,0,0,0,.125.592,1.309,1.309,0,0,0,.628.213c.227.035.515.043.627-.158a.391.391,0,0,0-.107-.454,1.126,1.126,0,0,0-.447-.221Z"
                      transform="translate(-349.544 -284.727)"
                      fill="#fafafa"
                    />
                  </g>
                  <g id="Group_4201" data-name="Group 4201">
                    <path
                      id="Path_16003"
                      data-name="Path 16003"
                      d="M334.488,279.532a1.579,1.579,0,0,0-.917,1.1c-.032.146-.028.329.1.407a.419.419,0,0,0,.309.008l1.313-.312a1.865,1.865,0,0,0-.592.314.632.632,0,0,0-.224.6.608.608,0,0,0,.608.409,1.309,1.309,0,0,0,.723-.288.923.923,0,0,0,.457-.672c0-.282-.35-.542-.565-.362a4.818,4.818,0,0,0,1.409-.641,1.322,1.322,0,0,0,.408-.381.545.545,0,0,0,.041-.536c-.449-.815-1.016.381-1.292.488C335.742,279.863,335.152,279.255,334.488,279.532Z"
                      transform="translate(-332.084 -278.142)"
                      fill="#fafafa"
                    />
                    <path
                      id="Path_16004"
                      data-name="Path 16004"
                      d="M331.84,284.353a.432.432,0,0,0,.115.455.279.279,0,0,0,.42-.086,1.477,1.477,0,0,0-.788.444c-.183.247-.138.678.154.774a.715.715,0,0,0,.544-.122,9.858,9.858,0,0,0,1.356-.894c-.129.3.183.642.51.67a1.575,1.575,0,0,0,.912-.319c.344-.208.737-.527.647-.919a.67.67,0,0,0-.85-.392,1.946,1.946,0,0,0-.822.63c.184-.268-.078-.667-.4-.71a.975.975,0,0,0-.822.379c.365-.2.447-.722-.042-.783C332.456,283.44,331.916,284.087,331.84,284.353Z"
                      transform="translate(-331.477 -279.483)"
                      fill="#fafafa"
                    />
                    <path
                      id="Path_16005"
                      data-name="Path 16005"
                      d="M345.757,283.046a.528.528,0,1,0-.265,1.016.825.825,0,0,0-.556.29.432.432,0,0,0-.117.328.4.4,0,0,0,.393.3,1.152,1.152,0,0,0,.511-.143.942.942,0,0,0-.5.146.327.327,0,0,0-.075.463.433.433,0,0,0,.42.047,2.085,2.085,0,0,0,.861-.484.831.831,0,0,0,.72.3.494.494,0,0,0,.412-.588.523.523,0,0,0-.445-.324,1.349,1.349,0,0,0-.57.089,1.08,1.08,0,0,0,.458-.5c.069-.221-.08-.517-.311-.5-.26.021-.393.374-.6.5C345.839,283.746,346.312,283.253,345.757,283.046Z"
                      transform="translate(-335.375 -279.348)"
                      fill="#fafafa"
                    />
                    <g
                      id="Group_4198"
                      data-name="Group 4198"
                      transform="translate(5.325 2.515)"
                    >
                      <path
                        id="Path_16006"
                        data-name="Path 16006"
                        d="M339.379,281.49a1.059,1.059,0,0,0-.377.951,1.1,1.1,0,0,0,.562.971.9.9,0,0,0,1.154-.7,1.268,1.268,0,0,0-.707-1.269A.693.693,0,0,0,339.379,281.49Z"
                        transform="translate(-339 -281.387)"
                        fill="#fafafa"
                      />
                    </g>
                    <g
                      id="Group_4199"
                      data-name="Group 4199"
                      transform="translate(8.095 1.799)"
                    >
                      <path
                        id="Path_16007"
                        data-name="Path 16007"
                        d="M343.837,280.77l.122.105a.592.592,0,1,0,0,.737.887.887,0,0,0,1.035-.194.677.677,0,0,0-.142-.984.548.548,0,0,0-.793.469l-.143-.159Z"
                        transform="translate(-342.914 -280.375)"
                        fill="#fafafa"
                      />
                    </g>
                    <g
                      id="Group_4200"
                      data-name="Group 4200"
                      transform="translate(12.086 2.768)"
                    >
                      <path
                        id="Path_16008"
                        data-name="Path 16008"
                        d="M349.143,281.76a1.88,1.88,0,0,0-.564.8.648.648,0,0,0,.375.8c.316.08.617-.181.8-.454a.994.994,0,0,0,.194-.832c-.094-.28-.5-.446-.7-.23Z"
                        transform="translate(-348.554 -281.745)"
                        fill="#fafafa"
                      />
                    </g>
                    <path
                      id="Path_16009"
                      data-name="Path 16009"
                      d="M341.517,278.7a.536.536,0,0,0-.746-.205.649.649,0,0,0-.231.773.825.825,0,0,0,.677.487c.36.04.785-.251.7-.6a.768.768,0,0,0,.689.26,1.815,1.815,0,0,0,.715-.269c.3-.173.623-.442.592-.789a.62.62,0,0,0-.569-.514,1.053,1.053,0,0,0-.759.283,6.444,6.444,0,0,1-.483.44.609.609,0,0,1-.615.087Z"
                      transform="translate(-334.113 -277.833)"
                      fill="#fafafa"
                    />
                  </g>
                </g>
              </g>
              <g
                id="Group_4204"
                data-name="Group 4204"
                transform="translate(2.625 8.382)"
              >
                <path
                  id="Path_16010"
                  data-name="Path 16010"
                  d="M344.19,298.023h-9.064l-.887-9.135h10.838Z"
                  transform="translate(-333.226 -288.145)"
                  fill="#f0f0f0"
                />
                <path
                  id="Path_16011"
                  data-name="Path 16011"
                  d="M345.361,289.053H333.029l-.222-1.215h12.775Z"
                  transform="translate(-332.807 -287.838)"
                  fill="#fafafa"
                />
              </g>
            </g>
            <g
              id="Group_4217"
              data-name="Group 4217"
              transform="translate(19.022 33.71)"
            >
              <g id="Group_4206" data-name="Group 4206">
                <path
                  id="Path_16012"
                  data-name="Path 16012"
                  d="M330.7,335.663H320.3l3.26-10.5.477-1.536h2.353Z"
                  transform="translate(-300.547 -323.625)"
                  fill="#ebebeb"
                />
                <path
                  id="Path_16013"
                  data-name="Path 16013"
                  d="M318.593,323.625l-.477,1.536-3.26,10.5-9.618-.143-3.092-10.36-.477-1.536Z"
                  transform="translate(-295.102 -323.625)"
                  fill="#e0e0e0"
                />
                <path
                  id="Path_16014"
                  data-name="Path 16014"
                  d="M315.881,323.625l-.477,1.536-3.26,10.5-19.754-.294,4.208-11.745Z"
                  transform="translate(-292.39 -323.625)"
                  fill="#fafafa"
                />
                <path
                  id="Path_16015"
                  data-name="Path 16015"
                  d="M317.394,323.625l-.477,1.536h-19.35l.545-1.536Z"
                  transform="translate(-293.903 -323.625)"
                  fill="#ebebeb"
                />
              </g>
              <g
                id="Group_4211"
                data-name="Group 4211"
                transform="translate(2.3 2.252)"
              >
                <g id="Group_4207" data-name="Group 4207">
                  <path
                    id="Path_16016"
                    data-name="Path 16016"
                    d="M299.978,331.08H295.64l1.513-4.273,4.149.047Zm-3.837-.354h3.578l1.1-3.524-3.419-.038Z"
                    transform="translate(-295.64 -326.807)"
                    fill="#ebebeb"
                  />
                </g>
                <g
                  id="Group_4208"
                  data-name="Group 4208"
                  transform="translate(4.853)"
                >
                  <path
                    id="Path_16017"
                    data-name="Path 16017"
                    d="M306.834,331.08H302.5l1.513-4.273,4.148.047ZM303,330.726h3.577l1.1-3.524-3.42-.038Z"
                    transform="translate(-302.497 -326.807)"
                    fill="#ebebeb"
                  />
                </g>
                <g
                  id="Group_4209"
                  data-name="Group 4209"
                  transform="translate(9.705)"
                >
                  <path
                    id="Path_16018"
                    data-name="Path 16018"
                    d="M313.691,331.08h-4.338l1.514-4.273,4.148.047Zm-3.837-.354h3.577l1.1-3.524-3.42-.038Z"
                    transform="translate(-309.353 -326.807)"
                    fill="#ebebeb"
                  />
                </g>
                <g
                  id="Group_4210"
                  data-name="Group 4210"
                  transform="translate(14.558)"
                >
                  <path
                    id="Path_16019"
                    data-name="Path 16019"
                    d="M320.548,331.08H316.21l1.514-4.273,4.148.047Zm-3.837-.354h3.576l1.1-3.524-3.419-.038Z"
                    transform="translate(-316.21 -326.807)"
                    fill="#ebebeb"
                  />
                </g>
              </g>
              <g
                id="Group_4216"
                data-name="Group 4216"
                transform="translate(0.786 6.785)"
              >
                <g id="Group_4212" data-name="Group 4212">
                  <path
                    id="Path_16020"
                    data-name="Path 16020"
                    d="M297.839,337.485H293.5l1.514-4.273,4.148.047ZM294,337.131h3.577l1.1-3.524-3.42-.038Z"
                    transform="translate(-293.501 -333.212)"
                    fill="#ebebeb"
                  />
                </g>
                <g
                  id="Group_4213"
                  data-name="Group 4213"
                  transform="translate(4.853)"
                >
                  <path
                    id="Path_16021"
                    data-name="Path 16021"
                    d="M304.7,337.485h-4.338l1.513-4.273,4.149.047Zm-3.837-.354h3.576l1.1-3.524-3.419-.038Z"
                    transform="translate(-300.358 -333.212)"
                    fill="#ebebeb"
                  />
                </g>
                <g
                  id="Group_4214"
                  data-name="Group 4214"
                  transform="translate(9.705)"
                >
                  <path
                    id="Path_16022"
                    data-name="Path 16022"
                    d="M311.552,337.485h-4.338l1.514-4.273,4.149.047Zm-3.837-.354h3.577l1.1-3.524-3.42-.038Z"
                    transform="translate(-307.214 -333.212)"
                    fill="#ebebeb"
                  />
                </g>
                <g
                  id="Group_4215"
                  data-name="Group 4215"
                  transform="translate(14.559)"
                >
                  <path
                    id="Path_16023"
                    data-name="Path 16023"
                    d="M318.409,337.485h-4.337l1.513-4.273,4.148.047Zm-3.837-.354h3.577l1.1-3.524-3.419-.038Z"
                    transform="translate(-314.072 -333.212)"
                    fill="#ebebeb"
                  />
                </g>
              </g>
            </g>
          </g>
          <g
            id="Group_4244"
            data-name="Group 4244"
            transform="translate(104.532)"
          >
            <g
              id="Group_4219"
              data-name="Group 4219"
              transform="translate(0 16.751)"
            >
              <path
                id="Path_16024"
                data-name="Path 16024"
                d="M413.211,289.28a8.617,8.617,0,0,0,.939,4.6,2.435,2.435,0,0,0,2.064,1.089h3.229a2.434,2.434,0,0,0,2.064-1.089,8.615,8.615,0,0,0,.94-4.6c0-3.234-1.41-5.824-1.871-7.892a11.675,11.675,0,0,1,.386-3.026H414.7a11.675,11.675,0,0,1,.386,3.026C414.621,283.456,413.211,286.046,413.211,289.28Z"
                transform="translate(-413.211 -278.362)"
                fill="#f0f0f0"
              />
            </g>
            <g
              id="Group_4243"
              data-name="Group 4243"
              transform="translate(0.176)"
            >
              <g
                id="Group_4233"
                data-name="Group 4233"
                transform="translate(4.671)"
              >
                <g
                  id="Group_4221"
                  data-name="Group 4221"
                  transform="translate(0 1.135)"
                >
                  <g id="Group_4220" data-name="Group 4220">
                    <path
                      id="Path_16025"
                      data-name="Path 16025"
                      d="M421.922,256.3a3.34,3.34,0,0,0-1.672,1.084c-.616.82.447,2.75.447,2.75a2.6,2.6,0,0,0,2.253.719l1.249-.305s-1.321-3.783-2.268-4Z"
                      transform="translate(-420.059 -256.297)"
                      fill="#ebebeb"
                    />
                  </g>
                </g>
                <g
                  id="Group_4227"
                  data-name="Group 4227"
                  transform="translate(1.456)"
                >
                  <g id="Group_4222" data-name="Group 4222">
                    <path
                      id="Path_16026"
                      data-name="Path 16026"
                      d="M427.451,256.733c-.166,1.644-1.554,3.5-3.023,3.348s-2.46-2.239-2.294-3.883,1.362-1.582,2.83-1.434S427.617,255.088,427.451,256.733Z"
                      transform="translate(-422.115 -254.694)"
                      fill="#ebebeb"
                    />
                  </g>
                  <g
                    id="Group_4223"
                    data-name="Group 4223"
                    transform="translate(1.106 0.763)"
                  >
                    <path
                      id="Path_16027"
                      data-name="Path 16027"
                      d="M423.766,255.771a4.189,4.189,0,0,0,3.309,1S423.035,258.49,423.766,255.771Z"
                      transform="translate(-423.678 -255.771)"
                      fill="#ebebeb"
                    />
                  </g>
                  <g
                    id="Group_4224"
                    data-name="Group 4224"
                    transform="translate(2.228 0.553)"
                  >
                    <path
                      id="Path_16028"
                      data-name="Path 16028"
                      d="M425.264,255.547s1.315.019,1.234.554c0,0,1.091.144,1.028-.336S425.264,255.547,425.264,255.547Z"
                      transform="translate(-425.264 -255.475)"
                      fill="#ebebeb"
                    />
                  </g>
                  <g
                    id="Group_4225"
                    data-name="Group 4225"
                    transform="translate(1.106 0.763)"
                  >
                    <path
                      id="Path_16029"
                      data-name="Path 16029"
                      d="M423.766,255.771a4.189,4.189,0,0,0,3.309,1S423.035,258.49,423.766,255.771Z"
                      transform="translate(-423.678 -255.771)"
                      fill="#e0e0e0"
                    />
                  </g>
                  <g
                    id="Group_4226"
                    data-name="Group 4226"
                    transform="translate(2.228 0.553)"
                  >
                    <path
                      id="Path_16030"
                      data-name="Path 16030"
                      d="M425.264,255.547s1.315.019,1.234.554c0,0,1.091.144,1.028-.336S425.264,255.547,425.264,255.547Z"
                      transform="translate(-425.264 -255.475)"
                      fill="#e0e0e0"
                    />
                  </g>
                </g>
                <g
                  id="Group_4228"
                  data-name="Group 4228"
                  transform="translate(1.246 2.66)"
                >
                  <path
                    id="Path_16031"
                    data-name="Path 16031"
                    d="M421.82,261.232a2.406,2.406,0,0,0,2.072,1.453,3.217,3.217,0,0,0,2.412-.957,4.922,4.922,0,0,0,1.263-2.318c.057-.224.182-.786-.1-.929-.258-.132-.5.218-.66.372a9.07,9.07,0,0,1-1.483,1.192,8.112,8.112,0,0,1-1.683.8C423.477,260.9,421.877,261.379,421.82,261.232Z"
                    transform="translate(-421.82 -258.452)"
                    fill="#ebebeb"
                  />
                </g>
                <g
                  id="Group_4229"
                  data-name="Group 4229"
                  transform="translate(5.082 1.936)"
                >
                  <path
                    id="Path_16032"
                    data-name="Path 16032"
                    d="M430.213,258.874a2.132,2.132,0,0,1-.636,1.974,3.717,3.717,0,0,1-1.243.677c-.31.115-.7.206-.938-.022-.258-.246-.149-.672-.017-1q.306-.764.653-1.512a5.4,5.4,0,0,1,.712-1.43c.3-.3.6-.032.908.285A2.107,2.107,0,0,1,430.213,258.874Z"
                    transform="translate(-427.24 -257.429)"
                    fill="#ebebeb"
                  />
                </g>
                <g
                  id="Group_4230"
                  data-name="Group 4230"
                  transform="translate(0.654 2.029)"
                >
                  <path
                    id="Path_16033"
                    data-name="Path 16033"
                    d="M422.114,260.145A1.511,1.511,0,0,1,421,258.979c-.077-.413.11-1.389.632-1.418A7,7,0,0,0,422.114,260.145Z"
                    transform="translate(-420.983 -257.561)"
                    fill="#e0e0e0"
                  />
                </g>
                <g
                  id="Group_4231"
                  data-name="Group 4231"
                  transform="translate(5.77 2.66)"
                >
                  <path
                    id="Path_16034"
                    data-name="Path 16034"
                    d="M428.212,260.694a1.713,1.713,0,0,0,1.335-.892c.143-.272.311-1.773-.246-1.234-.182.176-.278.83-.4,1.079A5.353,5.353,0,0,1,428.212,260.694Z"
                    transform="translate(-428.212 -258.451)"
                    fill="#e0e0e0"
                  />
                </g>
                <g
                  id="Group_4232"
                  data-name="Group 4232"
                  transform="translate(1.967 5.382)"
                >
                  <path
                    id="Path_16035"
                    data-name="Path 16035"
                    d="M424.452,262.35a1.241,1.241,0,0,0,1.476.319c-.11.275-1.056.344-1.351.374-.768.076-1.088-.316-1.739-.745C422.838,262.3,423.924,262.679,424.452,262.35Z"
                    transform="translate(-422.838 -262.298)"
                    fill="#e0e0e0"
                  />
                </g>
              </g>
              <g
                id="Group_4235"
                data-name="Group 4235"
                transform="translate(3.576 6.817)"
              >
                <g id="Group_4234" data-name="Group 4234">
                  <path
                    id="Path_16036"
                    data-name="Path 16036"
                    d="M418.512,289.089l1.809-18.279,2.4-6.485.415.153-2.386,6.456-1.891,18.653Z"
                    transform="translate(-418.512 -264.325)"
                    fill="#e6e6e6"
                  />
                </g>
              </g>
              <g
                id="Group_4242"
                data-name="Group 4242"
                transform="translate(0 5.404)"
              >
                <g
                  id="Group_4236"
                  data-name="Group 4236"
                  transform="translate(3.183 2.21)"
                >
                  <path
                    id="Path_16037"
                    data-name="Path 16037"
                    d="M420.57,271.1l-.395.2a12.912,12.912,0,0,1-.693-1.912,15.756,15.756,0,0,0-1.525-3.706l.377-.232a16.081,16.081,0,0,1,1.571,3.808A12.657,12.657,0,0,0,420.57,271.1Z"
                    transform="translate(-417.957 -265.451)"
                    fill="#e6e6e6"
                  />
                </g>
                <g
                  id="Group_4237"
                  data-name="Group 4237"
                  transform="translate(4.671 2.379)"
                >
                  <path
                    id="Path_16038"
                    data-name="Path 16038"
                    d="M422.159,268.775a2.592,2.592,0,0,0,1.646-.756,5.167,5.167,0,0,0,1.011-1.825c-.8.084-1.551-.44-2.356-.5a2.108,2.108,0,0,0-1.721.713c-.546.631-.865,1.4-.563,1.8A2.736,2.736,0,0,0,422.159,268.775Z"
                    transform="translate(-420.059 -265.691)"
                    fill="#f0f0f0"
                  />
                </g>
                <g
                  id="Group_4239"
                  data-name="Group 4239"
                  transform="translate(0 2.944)"
                >
                  <g id="Group_4238" data-name="Group 4238">
                    <path
                      id="Path_16039"
                      data-name="Path 16039"
                      d="M413.76,267.03a3.075,3.075,0,0,1,2.585-.415,2.312,2.312,0,0,1,1.411,1.572,1.451,1.451,0,0,1-1.384.544,4.27,4.27,0,0,1-1.457-.55,4.283,4.283,0,0,0-1.457-.549Z"
                      transform="translate(-413.459 -266.488)"
                      fill="#f0f0f0"
                    />
                  </g>
                </g>
                <g
                  id="Group_4241"
                  data-name="Group 4241"
                  transform="translate(0.891)"
                >
                  <g id="Group_4240" data-name="Group 4240">
                    <path
                      id="Path_16040"
                      data-name="Path 16040"
                      d="M418.117,266.161c-1.049.117-1.989.326-2.943-.867-.639-.8-.434-2.009-.387-2.965a21.156,21.156,0,0,1,3.432,1.45,1.677,1.677,0,0,1,.923,1.12.964.964,0,0,1-.762,1.087C418.362,265.96,418.117,266.161,418.117,266.161Z"
                      transform="translate(-414.718 -262.329)"
                      fill="#f0f0f0"
                    />
                  </g>
                </g>
              </g>
            </g>
            <path
              id="Path_16041"
              data-name="Path 16041"
              d="M414.982,286.3a8.716,8.716,0,0,0-.684,3.749c.026.241.1.515.275.558s.321-.159.379-.377a2.662,2.662,0,0,0,.042-.681c0-1.96,1.062-3.612,1.265-5.524.057-.544-.083-2.26-.4-1C415.573,284.147,415.371,285.2,414.982,286.3Z"
              transform="translate(-413.521 -262.841)"
              fill="#fafafa"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
